import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';



function Badge({ children, color }) {
  const colors = {
    pending: { bg: '#fff3e0', text: '#c06030', border: '#e0c080' },
    approved: { bg: '#e8f5e9', text: '#1a6a30', border: '#a0c8a0' },
    rejected: { bg: '#ffeaea', text: '#c03030', border: '#e0a0a0' },
  };
  const c = colors[color] || colors.pending;
  return <span style={{ background: c.bg, color: c.text, border: `1px solid ${c.border}`, borderRadius: '4px', padding: '2px 8px', fontSize: '12px', fontWeight: '500' }}>{children}</span>;
}

function TestiCard({ t, onApprove, onReject, onView, onDelete }) {
  return (
    <div style={{ background: '#fff', border: '1px solid #dccfc8', borderRadius: '10px', padding: '16px', marginBottom: '10px' }}>
      <div style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', marginBottom: '10px' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
          <div style={{ width: '32px', height: '32px', borderRadius: '50%', background: '#f5eeeb', border: '1px solid #c49090', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '12px', color: '#8b1a2a', fontWeight: '500', flexShrink: 0 }}>
            {t.authorName?.slice(0,2).toUpperCase()}
          </div>
          <div>
            <div style={{ fontSize: '13px', fontWeight: '500', color: '#1a1010' }}>{t.authorName} <span style={{ fontSize: '12px' }}>{t.authorCountry}</span></div>
            <div style={{ fontSize: '12px', color: '#9a8080', marginTop: '2px' }}>{t.location?.city} {t.eventDate} · {new Date(t.createdAt).toLocaleDateString('fr-FR')}</div>
          </div>
        </div>
        <div style={{ display: 'flex', gap: '6px', alignItems: 'center', flexShrink: 0 }}>
          <span style={{ display: 'inline-block', fontSize: '12px', background: '#f5eeeb', color: '#8b1a2a', padding: '2px 8px', borderRadius: '4px' }}>{t.section}</span>
          <Badge color={t.status}>{t.status === 'pending' ? '⏳ En attente' : t.status === 'approved' ? '✓ Approuvé' : '✗ Refusé'}</Badge>
        </div>
      </div>
      {t.eventName && <div style={{ fontSize: '12px', color: '#6a5050', marginBottom: '6px' }}>{t.eventName}</div>}
      <p style={{ fontSize: '12px', color: '#4a3030', lineHeight: '1.6', fontStyle: 'italic', fontFamily: 'Georgia,serif', overflow: 'hidden', display: '-webkit-box', WebkitLineClamp: 2, WebkitBoxOrient: 'vertical', marginBottom: '10px' }}>"{t.content}"</p>
      {t.photos?.length > 0 && (
        <div style={{ display: 'flex', gap: '6px', marginBottom: '10px' }}>
          {t.photos.map((_, i) => <div key={i} style={{ width: '40px', height: '40px', borderRadius: '6px', background: '#f5eeeb', border: '1px solid #dccfc8', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '16px' }}>📸</div>)}
          <div style={{ fontSize: '12px', color: '#9a8080', alignSelf: 'center', marginLeft: '4px' }}>{t.photos.length} fichier{t.photos.length > 1 ? 's' : ''}</div>
        </div>
      )}
      <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
        {t.status !== 'approved' && <button onClick={() => onApprove(t._id)} style={{ background: '#1a6a30', color: '#fff', border: 'none', borderRadius: '6px', padding: '6px 16px', fontSize: '12px', cursor: 'pointer', fontWeight: '500' }}>✓ Approuver</button>}
        {t.status !== 'rejected' && <button onClick={() => onReject(t._id)} style={{ background: '#fff', color: '#c03030', border: '1px solid #e0a0a0', borderRadius: '6px', padding: '6px 16px', fontSize: '12px', cursor: 'pointer' }}>✗ Refuser</button>}
        <button onClick={() => onDelete(t._id)} style={{ background: '#8b1a2a', color: '#fff', border: 'none', borderRadius: '6px', padding: '6px 12px', fontSize: '12px', cursor: 'pointer' }}>🗑 Supprimer</button>
        <button onClick={() => onView(t)} style={{ background: '#f5eeeb', color: '#8b1a2a', border: '1px solid #c49090', borderRadius: '6px', padding: '6px 12px', fontSize: '12px', cursor: 'pointer', marginLeft: 'auto' }}>Lire en entier →</button>
      </div>
    </div>
  );
}

function TestiFull({ t, onClose, onApprove, onReject, onDelete }) {
  return (
    <div style={{ background: '#fff', borderRadius: '10px', padding: '24px', marginBottom: '10px' }}>
      <button onClick={onClose} style={{ fontSize: '12px', color: '#9a8080', background: 'none', border: 'none', cursor: 'pointer', marginBottom: '16px', display: 'block' }}>← Retour à la liste</button>
      <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '12px' }}>
        <div style={{ width: '40px', height: '40px', borderRadius: '50%', background: '#f5eeeb', border: '1px solid #c49090', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '13px', color: '#8b1a2a', fontWeight: '500' }}>
          {t.authorName?.slice(0,2).toUpperCase()}
        </div>
        <div>
          <div style={{ fontSize: '15px', fontWeight: '500', color: '#1a1010' }}>{t.authorName}</div>
          <div style={{ fontSize: '12px', color: '#9a8080' }}>{t.authorCountry} · {t.location?.city} · {t.eventDate}</div>
        </div>
        <div style={{ marginLeft: 'auto' }}><Badge color={t.status}>{t.status === 'pending' ? '⏳ En attente' : t.status === 'approved' ? '✓ Approuvé' : '✗ Refusé'}</Badge></div>
      </div>
      {t.eventName && <div style={{ fontSize: '12px', color: '#8b1a2a', marginBottom: '12px', fontWeight: '500' }}>{t.eventName}</div>}
      <p style={{ fontSize: '14px', color: '#1a1010', lineHeight: '1.8', fontStyle: 'italic', fontFamily: 'Georgia,serif', marginBottom: '16px' }}>"{t.content}"</p>
      {t.photos?.length > 0 && (
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8, marginBottom: 16 }}>
          {t.photos.map((p, i) => <img key={i} src={p} alt="" style={{ width: 120, height: 120, objectFit: 'cover', borderRadius: 8, border: '1px solid #e8d5d0' }} />)}
        </div>
      )}
      {t.videos?.length > 0 && (
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8, marginBottom: 16 }}>
          {t.videos.map((v, i) => <video key={i} src={v} controls style={{ width: 280, borderRadius: 8, border: '1px solid #e8d5d0' }} />)}
        </div>
      )}
      {t.videoUrl && (() => {
        const u = t.videoUrl; let embed = '';
        const yt = u.match(/(?:youtube\.com\/(?:watch\?v=|embed\/|shorts\/)|youtu\.be\/)([\w-]{11})/);
        const vm = u.match(/vimeo\.com\/(?:video\/)?(\d+)/);
        if (yt) embed = 'https://www.youtube.com/embed/' + yt[1];
        else if (vm) embed = 'https://player.vimeo.com/video/' + vm[1];
        return embed
          ? <div style={{ marginBottom: 16 }}><iframe title="video" src={embed} style={{ width: '100%', maxWidth: 420, aspectRatio: '16 / 9', border: '1px solid #e8d5d0', borderRadius: 8 }} allow="accelerometer; autoplay; encrypted-media; picture-in-picture; clipboard-write" allowFullScreen /></div>
          : <div style={{ marginBottom: 16 }}><a href={u} target="_blank" rel="noreferrer" style={{ fontSize: 13, color: '#8b1a2a' }}>{u}</a></div>;
      })()}
      <div style={{ fontSize: '12px', color: '#9a8080', marginBottom: '16px' }}>
        <span style={{ background: '#f5eeeb', color: '#8b1a2a', padding: '2px 8px', borderRadius: '4px', marginRight: '8px' }}>Section : {t.section}</span>
        Droits cédés : {t.rightsAccepted ? '✓ Oui' : '✗ Non'}
      </div>
      <div style={{ display: 'flex', gap: '8px' }}>
        {t.status !== 'approved' && <button onClick={() => onApprove(t._id)} style={{ background: '#1a6a30', color: '#fff', border: 'none', borderRadius: '7px', padding: '10px 24px', fontSize: '13px', cursor: 'pointer', fontWeight: '500' }}>✓ Approuver</button>}
        {t.status !== 'rejected' && <button onClick={() => onReject(t._id)} style={{ background: '#fff', color: '#c03030', border: '1px solid #e0a0a0', borderRadius: '7px', padding: '10px 24px', fontSize: '13px', cursor: 'pointer' }}>✗ Refuser</button>}
        <button onClick={() => onDelete(t._id)} style={{ background: '#8b1a2a', color: '#fff', border: 'none', borderRadius: '7px', padding: '10px 24px', fontSize: '13px', cursor: 'pointer' }}>🗑 Supprimer</button>
      </div>
    </div>
  );
}

function SectionVideos() {
  const [videos, setVideos] = useState([]);
  const [uploading, setUploading] = useState(false);
  const [progress, setProgress] = useState(0);
  const [message, setMessage] = useState(null);
  const [form, setForm] = useState({ titre: '', annee: '', type: 'CLIP OFFICIEL', description: '' });
  const fileRef = useRef();

  useEffect(() => { chargerVideos(); }, []);

  const chargerVideos = async () => {
    try {
      const res = await fetch('/api/videos');
      const data = await res.json();
      setVideos(data);
    } catch(e) { console.error(e); }
  };

  const handleUpload = () => {
    const file = fileRef.current?.files[0];
    if (!file) return setMessage({ type: 'error', texte: 'Sélectionnez une vidéo' });
    if (!form.titre.trim()) return setMessage({ type: 'error', texte: 'Le titre est obligatoire' });
    const fd = new FormData();
    fd.append('video', file);
    fd.append('titre', form.titre);
    fd.append('annee', form.annee);
    fd.append('type', form.type);
    fd.append('description', form.description);
    setUploading(true); setProgress(0);
    const xhr = new XMLHttpRequest();
    xhr.upload.onprogress = e => { if (e.lengthComputable) setProgress(Math.round(e.loaded / e.total * 100)); };
    xhr.onload = () => {
      setUploading(false);
      if (xhr.status === 200) {
        setMessage({ type: 'success', texte: 'Vidéo uploadée !' });
        setForm({ titre: '', annee: '', type: 'CLIP OFFICIEL', description: '' });
        if (fileRef.current) fileRef.current.value = '';
        chargerVideos();
      } else { setMessage({ type: 'error', texte: "Erreur lors de l'upload" }); }
    };
    xhr.onerror = () => { setUploading(false); setMessage({ type: 'error', texte: 'Erreur réseau' }); };
    xhr.open('POST', '/api/videos/upload');
    xhr.send(fd);
  };

  const handleSupprimer = async (filename) => {
    if (!window.confirm(`Supprimer "${filename}" ?`)) return;
    await fetch(`/api/videos/${filename}`, { method: 'DELETE' });
    chargerVideos();
  };

  return (
    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1.4fr', gap: 24, alignItems: 'start' }}>
      <div style={{ background: '#fff', border: '1px solid #dccfc8', borderRadius: 10, padding: '20px' }}>
        <div style={{ fontFamily: 'Georgia,serif', fontSize: 16, color: '#8b1a2a', marginBottom: 16 }}>Ajouter une vidéo</div>
        {message && <div style={{ padding: '8px 12px', borderRadius: 6, marginBottom: 12, background: message.type === 'success' ? '#e8f5ee' : '#f5e8e8', color: message.type === 'success' ? '#1a5a3a' : '#8b1a2a', fontSize: 12 }}>{message.texte}</div>}
        {[{ label: 'Titre *', key: 'titre' }, { label: 'Année', key: 'annee' }].map(f => (
          <div key={f.key} style={{ marginBottom: 12 }}>
            <label style={{ display: 'block', fontSize: 12, fontWeight: 700, color: '#4a3030', marginBottom: 4 }}>{f.label}</label>
            <input value={form[f.key]} onChange={e => setForm(p => ({ ...p, [f.key]: e.target.value }))}
              style={{ width: '100%', padding: '8px 10px', borderRadius: 6, border: '1px solid #dccfc8', fontSize: 12, boxSizing: 'border-box' }} />
          </div>
        ))}
        <div style={{ marginBottom: 12 }}>
          <label style={{ display: 'block', fontSize: 12, fontWeight: 700, color: '#4a3030', marginBottom: 4 }}>Type</label>
          <select value={form.type} onChange={e => setForm(p => ({ ...p, type: e.target.value }))}
            style={{ width: '100%', padding: '8px 10px', borderRadius: 6, border: '1px solid #dccfc8', fontSize: 12 }}>
            {['CLIP OFFICIEL', 'LIVE HISTORIQUE', 'CONCERT', 'LIVE RARE', 'COULISSES'].map(o => <option key={o}>{o}</option>)}
          </select>
        </div>
        <div style={{ marginBottom: 12 }}>
          <label style={{ display: 'block', fontSize: 12, fontWeight: 700, color: '#4a3030', marginBottom: 4 }}>Description</label>
          <textarea value={form.description} onChange={e => setForm(p => ({ ...p, description: e.target.value }))} rows={3}
            style={{ width: '100%', padding: '8px 10px', borderRadius: 6, border: '1px solid #dccfc8', fontSize: 12, resize: 'vertical', boxSizing: 'border-box' }} />
        </div>
        <div style={{ marginBottom: 16 }}>
          <label style={{ display: 'block', fontSize: 12, fontWeight: 700, color: '#4a3030', marginBottom: 4 }}>Fichier vidéo (MP4, WebM) *</label>
          <input ref={fileRef} type="file" accept="video/mp4,video/webm,video/ogg"
            style={{ width: '100%', padding: '8px 10px', borderRadius: 6, border: '1px solid #dccfc8', fontSize: 12, boxSizing: 'border-box' }} />
        </div>
        {uploading && (
          <div style={{ marginBottom: 12 }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: 12, color: '#6a5050', marginBottom: 4 }}>
              <span>Upload en cours…</span><span>{progress}%</span>
            </div>
            <div style={{ height: 6, background: '#f5eeeb', borderRadius: 3, overflow: 'hidden' }}>
              <div style={{ height: '100%', background: '#8b1a2a', width: `${progress}%`, transition: 'width 0.3s' }}></div>
            </div>
          </div>
        )}
        <button onClick={handleUpload} disabled={uploading}
          style={{ width: '100%', padding: '10px', borderRadius: 6, border: 'none', background: uploading ? '#c49090' : '#8b1a2a', color: '#fff', fontWeight: 700, fontSize: 13, cursor: uploading ? 'not-allowed' : 'pointer' }}>
          {uploading ? `Upload ${progress}%…` : '⬆ Uploader la vidéo'}
        </button>
      </div>

      <div>
        <div style={{ fontFamily: 'Georgia,serif', fontSize: 16, color: '#1a1010', marginBottom: 12 }}>
          Vidéos stockées <span style={{ fontSize: 13, color: '#8b1a2a' }}>({videos.length})</span>
        </div>
        {videos.length === 0 ? (
          <div style={{ background: '#fff', border: '1px solid #dccfc8', borderRadius: 10, padding: 24, textAlign: 'center', color: '#9a8080', fontSize: 13 }}>Aucune vidéo uploadée.</div>
        ) : (
          <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
            {videos.map(v => (
              <div key={v.filename} style={{ background: '#fff', border: '1px solid #dccfc8', borderRadius: 10, padding: '12px 14px', display: 'flex', gap: 12, alignItems: 'center' }}>
                <video src={v.url} style={{ width: 100, height: 60, objectFit: 'cover', borderRadius: 6, background: '#1a0808', flexShrink: 0 }} />
                <div style={{ flex: 1, minWidth: 0 }}>
                  <div style={{ fontSize: 12, fontWeight: 700, color: '#1a1010', marginBottom: 2, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{v.filename}</div>
                  <a href={v.url} target="_blank" rel="noreferrer" style={{ fontSize: 12, color: '#8b1a2a', wordBreak: 'break-all' }}>{v.url}</a>
                </div>
                <button onClick={() => handleSupprimer(v.filename)}
                  style={{ padding: '6px 12px', borderRadius: 6, border: '1px solid #e0a0a0', background: '#fff', color: '#c03030', fontSize: 12, cursor: 'pointer', flexShrink: 0 }}>
                  🗑
                </button>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}






function SectionCitations() {
  const [items, setItems] = React.useState([]);
  const [text, setText] = React.useState('');
  const [source, setSource] = React.useState('— Michael Jackson');
  const [message, setMessage] = React.useState(null);

  const fetchItems = async () => {
    const res = await fetch('/api/citations');
    const data = await res.json();
    if (Array.isArray(data)) setItems(data);
  };

  React.useEffect(() => { fetchItems(); }, []);

  const handleSubmit = async () => {
    if (!text.trim()) return setMessage({ type: 'error', texte: 'La citation est obligatoire' });
    await fetch('/api/citations', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ text, source })
    });
    setText('');
    setSource('— Michael Jackson');
    setMessage({ type: 'success', texte: 'Citation ajoutee !' });
    fetchItems();
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Supprimer cette citation ?')) return;
    await fetch('/api/citations/' + id, { method: 'DELETE' });
    fetchItems();
  };

  return (
    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1.4fr', gap: 24, alignItems: 'start' }}>
      <div style={{ background: '#fff', border: '1px solid #dccfc8', borderRadius: 10, padding: 20 }}>
        <div style={{ fontFamily: 'Georgia,serif', fontSize: 16, color: '#8b1a2a', marginBottom: 16 }}>Ajouter une citation</div>
        {message && <div style={{ padding: '8px 12px', borderRadius: 6, marginBottom: 12, background: message.type === 'success' ? '#e8f5ee' : '#f5e8e8', color: message.type === 'success' ? '#1a5a3a' : '#8b1a2a', fontSize: 12 }}>{message.texte}</div>}
        <div style={{ marginBottom: 12 }}>
          <label style={{ display: 'block', fontSize: 12, fontWeight: 700, color: '#4a3030', marginBottom: 4 }}>Texte *</label>
          <textarea value={text} onChange={e => setText(e.target.value)} rows={4} placeholder="Entrez la citation..."
            style={{ width: '100%', padding: '8px 10px', borderRadius: 6, border: '1px solid #dccfc8', fontSize: 13, fontFamily: 'Georgia,serif', fontStyle: 'italic', resize: 'vertical', boxSizing: 'border-box' }} />
        </div>
        <div style={{ marginBottom: 16 }}>
          <label style={{ display: 'block', fontSize: 12, fontWeight: 700, color: '#4a3030', marginBottom: 4 }}>Source</label>
          <input value={source} onChange={e => setSource(e.target.value)}
            style={{ width: '100%', padding: '8px 10px', borderRadius: 6, border: '1px solid #dccfc8', fontSize: 12, boxSizing: 'border-box' }} />
        </div>
        <button onClick={handleSubmit} style={{ width: '100%', padding: 10, borderRadius: 6, border: 'none', background: '#8b1a2a', color: '#fff', fontWeight: 700, fontSize: 13, cursor: 'pointer' }}>
          Ajouter
        </button>
      </div>

      <div>
        <div style={{ fontFamily: 'Georgia,serif', fontSize: 16, color: '#1a1010', marginBottom: 12 }}>
          Citations ({items.length})
        </div>
        {items.length === 0 ? (
          <div style={{ background: '#fff', border: '1px solid #dccfc8', borderRadius: 10, padding: 24, textAlign: 'center', color: '#9a8080', fontSize: 13 }}>Aucune citation.</div>
        ) : (
          <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
            {items.map(item => (
              <div key={item._id} style={{ background: '#fff', border: '1px solid #dccfc8', borderRadius: 10, padding: '14px 16px', display: 'flex', gap: 12, alignItems: 'flex-start' }}>
                <div style={{ flex: 1 }}>
                  <div style={{ fontSize: 13, color: '#1a1010', fontStyle: 'italic', fontFamily: 'Georgia,serif', lineHeight: 1.6, marginBottom: 4 }}>"{item.text}"</div>
                  <div style={{ fontSize: 12, color: '#8b1a2a' }}>{item.source}</div>
                </div>
                <button onClick={() => handleDelete(item._id)} style={{ padding: '6px 12px', borderRadius: 6, border: '1px solid #e0a0a0', background: '#fff', color: '#c03030', fontSize: 12, cursor: 'pointer', flexShrink: 0 }}>🗑</button>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
function SectionLegende() {
  const CATS = [
    { key: 'hommages', label: 'Hommages fans', color: '#8b1a2a' },
    { key: 'associations', label: 'Associations', color: '#b05070' },
    { key: 'solidaires', label: 'Actions solidaires', color: '#c47840' },
    { key: 'divers', label: 'Divers', color: '#9a8080' }
  ];
  const CAT_COLOR = { hommages: '#8b1a2a', associations: '#b05070', solidaires: '#c47840', divers: '#9a8080' };
  const [items, setItems] = React.useState([]);
  const [pending, setPending] = React.useState([]);
  const [form, setForm] = React.useState({ title: '', content: '', category: 'hommages', eventDate: '', sourceUrl: '', pinned: false });
  const [file, setFile] = React.useState(null);
  const [loading, setLoading] = React.useState(false);
  const [message, setMessage] = React.useState(null);
  const fileRef = React.useRef();

  const fetchItems = async () => {
    const res = await fetch('/api/legend-news');
    const data = await res.json();
    if (Array.isArray(data)) setItems(data);
  };
  const fetchPending = async () => {
    const res = await fetch('/api/legend-news/pending');
    const data = await res.json();
    if (Array.isArray(data)) setPending(data);
  };
  React.useEffect(() => { fetchItems(); fetchPending(); }, []);

  const handleSubmit = async () => {
    if (!form.title || !form.content) return setMessage({ type: 'error', texte: 'Titre et contenu obligatoires' });
    setLoading(true);
    const fd = new FormData();
    Object.entries(form).forEach(([k,v]) => fd.append(k, v));
    if (file) fd.append('image', file);
    await fetch('/api/legend-news', { method: 'POST', body: fd });
    setLoading(false);
    setMessage({ type: 'success', texte: 'Article publie !' });
    setForm({ title: '', content: '', category: 'hommages', eventDate: '', sourceUrl: '', pinned: false });
    setFile(null);
    if (fileRef.current) fileRef.current.value = '';
    fetchItems();
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Supprimer ?')) return;
    await fetch('/api/legend-news/' + id, { method: 'DELETE' });
    fetchItems(); fetchPending();
  };

  const handlePin = async (id) => {
    await fetch('/api/legend-news/' + id + '/pin', { method: 'PATCH' });
    fetchItems();
  };

  const handleApprove = async (id) => {
    await fetch('/api/legend-news/' + id + '/approve', { method: 'PATCH' });
    fetchPending(); fetchItems();
  };

  return (
    <div>
      {pending.length > 0 && (
        <div style={{ background: '#fff3e0', border: '1px solid #e0c080', borderRadius: 10, padding: 16, marginBottom: 24 }}>
          <div style={{ fontFamily: 'Georgia,serif', fontSize: 15, color: '#c06030', marginBottom: 12 }}>Propositions en attente ({pending.length})</div>
          {pending.map(item => (
            <div key={item._id} style={{ background: '#fff', border: '1px solid #dccfc8', borderRadius: 8, padding: '12px 14px', marginBottom: 8, display: 'flex', gap: 12, alignItems: 'flex-start' }}>
              <div style={{ flex: 1 }}>
                <div style={{ fontSize: 13, fontWeight: 700, color: '#1a1010', marginBottom: 2 }}>{item.title}</div>
                <div style={{ fontSize: 12, color: CAT_COLOR[item.category] }}>{item.category}</div>
                {item.submittedBy && <div style={{ fontSize: 12, color: '#9a8080' }}>Par {item.submittedBy.username}</div>}
                <div style={{ fontSize: 12, color: '#666', marginTop: 4 }}>{item.content.slice(0, 100)}...</div>
              </div>
              <div style={{ display: 'flex', gap: 6, flexShrink: 0 }}>
                <button onClick={() => handleApprove(item._id)} style={{ padding: '5px 12px', borderRadius: 6, border: 'none', background: '#1a6a30', color: '#fff', fontSize: 12, cursor: 'pointer' }}>Approuver</button>
                <button onClick={() => handleDelete(item._id)} style={{ padding: '5px 12px', borderRadius: 6, border: '1px solid #e0a0a0', background: '#fff', color: '#c03030', fontSize: 12, cursor: 'pointer' }}>Refuser</button>
              </div>
            </div>
          ))}
        </div>
      )}
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1.4fr', gap: 24, alignItems: 'start' }}>
        <div style={{ background: '#fff', border: '1px solid #dccfc8', borderRadius: 10, padding: 20 }}>
          <div style={{ fontFamily: 'Georgia,serif', fontSize: 16, color: '#8b1a2a', marginBottom: 16 }}>Publier un article</div>
          {message && <div style={{ padding: '8px 12px', borderRadius: 6, marginBottom: 12, background: message.type === 'success' ? '#e8f5ee' : '#f5e8e8', color: message.type === 'success' ? '#1a5a3a' : '#8b1a2a', fontSize: 12 }}>{message.texte}</div>}
          {[{ label: 'Titre *', key: 'title', ph: 'Titre de larticle' }, { label: 'Source URL', key: 'sourceUrl', ph: 'https://...' }].map(f => (
            <div key={f.key} style={{ marginBottom: 12 }}>
              <label style={{ display: 'block', fontSize: 12, fontWeight: 700, color: '#4a3030', marginBottom: 4 }}>{f.label}</label>
              <input value={form[f.key]} onChange={e => setForm(p => ({...p, [f.key]: e.target.value}))} placeholder={f.ph} style={{ width: '100%', padding: '8px 10px', borderRadius: 6, border: '1px solid #dccfc8', fontSize: 12, boxSizing: 'border-box' }} />
            </div>
          ))}
          <div style={{ marginBottom: 12 }}>
            <label style={{ display: 'block', fontSize: 12, fontWeight: 700, color: '#4a3030', marginBottom: 8 }}>Categorie *</label>
            <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap' }}>
              {CATS.map(c => (
                <button key={c.key} onClick={() => setForm(p => ({...p, category: c.key}))}
                  style={{ padding: '5px 10px', borderRadius: 20, border: '1px solid #c49090', fontSize: 12, cursor: 'pointer', background: form.category === c.key ? c.color : '#fafaf8', color: form.category === c.key ? '#fff' : '#8b1a2a' }}>
                  {c.label}
                </button>
              ))}
            </div>
          </div>
          <div style={{ marginBottom: 12 }}>
            <label style={{ display: 'block', fontSize: 12, fontWeight: 700, color: '#4a3030', marginBottom: 4 }}>Date evenement</label>
            <input type="date" value={form.eventDate} onChange={e => setForm(p => ({...p, eventDate: e.target.value}))} style={{ width: '100%', padding: '8px 10px', borderRadius: 6, border: '1px solid #dccfc8', fontSize: 12, boxSizing: 'border-box' }} />
          </div>
          <div style={{ marginBottom: 12 }}>
            <label style={{ display: 'block', fontSize: 12, fontWeight: 700, color: '#4a3030', marginBottom: 4 }}>Contenu *</label>
            <textarea value={form.content} onChange={e => setForm(p => ({...p, content: e.target.value}))} rows={6} style={{ width: '100%', padding: '8px 10px', borderRadius: 6, border: '1px solid #dccfc8', fontSize: 12, resize: 'vertical', boxSizing: 'border-box' }} />
          </div>
          <div style={{ marginBottom: 12 }}>
            <label style={{ display: 'block', fontSize: 12, fontWeight: 700, color: '#4a3030', marginBottom: 4 }}>Image</label>
            <input ref={fileRef} type="file" accept="image/*" onChange={e => setFile(e.target.files[0])} style={{ width: '100%', padding: '8px 10px', borderRadius: 6, border: '1px solid #dccfc8', fontSize: 12, boxSizing: 'border-box' }} />
          </div>
          <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 16 }}>
            <input type="checkbox" checked={form.pinned} onChange={e => setForm(p => ({...p, pinned: e.target.checked}))} />
            <label style={{ fontSize: 12, color: '#4a3030' }}>Epingler</label>
          </div>
          <button onClick={handleSubmit} disabled={loading} style={{ width: '100%', padding: 10, borderRadius: 6, border: 'none', background: loading ? '#c49090' : '#8b1a2a', color: '#fff', fontWeight: 700, fontSize: 13, cursor: 'pointer' }}>
            {loading ? 'Publication...' : 'Publier'}
          </button>
        </div>
        <div>
          <div style={{ fontFamily: 'Georgia,serif', fontSize: 16, color: '#1a1010', marginBottom: 12 }}>Articles publies ({items.length})</div>
          {items.map(item => (
            <div key={item._id} style={{ background: '#fff', border: item.pinned ? '1.5px solid #8b1a2a' : '1px solid #dccfc8', borderRadius: 10, padding: '12px 14px', marginBottom: 10, display: 'flex', gap: 12, alignItems: 'flex-start' }}>
              {item.imageUrl && <img src={item.imageUrl} alt="" style={{ width: 60, height: 45, objectFit: 'cover', borderRadius: 6, flexShrink: 0 }} />}
              <div style={{ flex: 1, minWidth: 0 }}>
                <div style={{ fontSize: 12, fontWeight: 700, color: '#1a1010', marginBottom: 2 }}>{item.pinned ? '📌 ' : ''}{item.title}</div>
                <div style={{ fontSize: 12, color: CAT_COLOR[item.category] }}>{item.category}</div>
              </div>
              <div style={{ display: 'flex', gap: 4, flexShrink: 0 }}>
                <button onClick={() => handlePin(item._id)} style={{ padding: '4px 8px', borderRadius: 6, border: '1px solid #c49090', background: '#f5eeeb', color: '#8b1a2a', fontSize: 12, cursor: 'pointer' }}>{item.pinned ? 'Desepingler' : 'Epingler'}</button>
                <button onClick={() => handleDelete(item._id)} style={{ padding: '4px 8px', borderRadius: 6, border: '1px solid #e0a0a0', background: '#fff', color: '#c03030', fontSize: 12, cursor: 'pointer' }}>🗑</button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
function SectionLegendeActus() {
  const CATS = [
    { key: 'hommages', label: 'Hommages fans', color: '#8b1a2a' },
    { key: 'associations', label: 'Associations', color: '#b05070' },
    { key: 'solidaires', label: 'Actions solidaires', color: '#c47840' },
    { key: 'divers', label: 'Divers', color: '#9a8080' }
  ];
  const CAT_COLOR = { hommages: '#8b1a2a', associations: '#b05070', solidaires: '#c47840', divers: '#9a8080' };
  const CAT_LABEL = { hommages: 'Hommages fans', associations: 'Associations', solidaires: 'Actions solidaires', divers: 'Divers' };
  const [items, setItems] = React.useState([]);
  const [form, setForm] = React.useState({ title: '', content: '', category: 'hommages' });
  const [file, setFile] = React.useState(null);
  const [editId, setEditId] = React.useState(null);
  const [loading, setLoading] = React.useState(false);
  const [message, setMessage] = React.useState(null);
  const fileRef = React.useRef();
  const token = localStorage.getItem('mjtoken');

  const fetchItems = async () => {
    const res = await fetch('/api/legende-actus');
    const data = await res.json();
    if (Array.isArray(data)) setItems(data);
  };
  React.useEffect(() => { fetchItems(); }, []);

  const resetForm = () => {
    setForm({ title: '', content: '', category: 'hommages' });
    setFile(null); setEditId(null);
    if (fileRef.current) fileRef.current.value = '';
  };

  const handleSubmit = async () => {
    if (!form.title || !form.content) return setMessage({ type: 'error', texte: 'Titre et texte obligatoires' });
    setLoading(true);
    const fd = new FormData();
    fd.append('title', form.title);
    fd.append('content', form.content);
    fd.append('category', form.category);
    if (file) fd.append('image', file);
    const url = editId ? '/api/legende-actus/' + editId : '/api/legende-actus';
    const method = editId ? 'PUT' : 'POST';
    const res = await fetch(url, { method, headers: { Authorization: 'Bearer ' + token }, body: fd });
    setLoading(false);
    if (res.ok) {
      setMessage({ type: 'success', texte: editId ? 'Actu modifiee !' : 'Actu publiee !' });
      resetForm(); fetchItems();
    } else {
      setMessage({ type: 'error', texte: 'Erreur lors de l\'enregistrement' });
    }
  };

  const handleEdit = (item) => {
    setEditId(item._id);
    setForm({ title: item.title, content: item.content, category: item.category });
    setFile(null);
    if (fileRef.current) fileRef.current.value = '';
    setMessage(null);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Supprimer cette actu ?')) return;
    await fetch('/api/legende-actus/' + id, { method: 'DELETE', headers: { Authorization: 'Bearer ' + token } });
    if (editId === id) resetForm();
    fetchItems();
  };

  return (
    <div>
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1.4fr', gap: 24, alignItems: 'start' }}>
        <div style={{ background: '#fff', border: '1px solid #dccfc8', borderRadius: 10, padding: 20 }}>
          <div style={{ fontFamily: 'Georgia,serif', fontSize: 16, color: '#8b1a2a', marginBottom: 16 }}>{editId ? 'Modifier l\'actu' : 'Nouvelle actu'}</div>
          {message && <div style={{ padding: '8px 12px', borderRadius: 6, marginBottom: 12, background: message.type === 'success' ? '#e8f5ee' : '#f5e8e8', color: message.type === 'success' ? '#1a5a3a' : '#8b1a2a', fontSize: 12 }}>{message.texte}</div>}
          <div style={{ marginBottom: 12 }}>
            <label style={{ display: 'block', fontSize: 12, fontWeight: 700, color: '#4a3030', marginBottom: 4 }}>Titre *</label>
            <input value={form.title} onChange={e => setForm(p => ({...p, title: e.target.value}))} placeholder="Titre de l'actu" style={{ width: '100%', padding: '8px 10px', borderRadius: 6, border: '1px solid #dccfc8', fontSize: 12, boxSizing: 'border-box' }} />
          </div>
          <div style={{ marginBottom: 12 }}>
            <label style={{ display: 'block', fontSize: 12, fontWeight: 700, color: '#4a3030', marginBottom: 8 }}>Categorie *</label>
            <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap' }}>
              {CATS.map(c => (
                <button key={c.key} onClick={() => setForm(p => ({...p, category: c.key}))}
                  style={{ padding: '5px 10px', borderRadius: 20, border: '1px solid #c49090', fontSize: 12, cursor: 'pointer', background: form.category === c.key ? c.color : '#fafaf8', color: form.category === c.key ? '#fff' : '#8b1a2a' }}>
                  {c.label}
                </button>
              ))}
            </div>
          </div>
          <div style={{ marginBottom: 12 }}>
            <label style={{ display: 'block', fontSize: 12, fontWeight: 700, color: '#4a3030', marginBottom: 4 }}>Texte *</label>
            <textarea value={form.content} onChange={e => setForm(p => ({...p, content: e.target.value}))} rows={6} style={{ width: '100%', padding: '8px 10px', borderRadius: 6, border: '1px solid #dccfc8', fontSize: 12, resize: 'vertical', boxSizing: 'border-box' }} />
          </div>
          <div style={{ marginBottom: 16 }}>
            <label style={{ display: 'block', fontSize: 12, fontWeight: 700, color: '#4a3030', marginBottom: 4 }}>Image (facultative)</label>
            <input ref={fileRef} type="file" accept="image/*" onChange={e => setFile(e.target.files[0])} style={{ width: '100%', padding: '8px 10px', borderRadius: 6, border: '1px solid #dccfc8', fontSize: 12, boxSizing: 'border-box' }} />
            {editId && <div style={{ fontSize: 12, color: '#9a8080', marginTop: 4 }}>Laisse vide pour garder l'image actuelle.</div>}
          </div>
          <div style={{ display: 'flex', gap: 8 }}>
            <button onClick={handleSubmit} disabled={loading} style={{ flex: 1, padding: 10, borderRadius: 6, border: 'none', background: loading ? '#c49090' : '#8b1a2a', color: '#fff', fontWeight: 700, fontSize: 13, cursor: 'pointer' }}>
              {loading ? 'Enregistrement...' : (editId ? 'Enregistrer les modifications' : 'Publier')}
            </button>
            {editId && <button onClick={resetForm} style={{ padding: '10px 14px', borderRadius: 6, border: '1px solid #c49090', background: '#fff', color: '#8b1a2a', fontSize: 12, cursor: 'pointer' }}>Annuler</button>}
          </div>
        </div>
        <div>
          <div style={{ fontFamily: 'Georgia,serif', fontSize: 16, color: '#1a1010', marginBottom: 12 }}>Actus publiees ({items.length})</div>
          {items.length === 0 && <div style={{ fontSize: 12, color: '#9a8080', fontStyle: 'italic' }}>Aucune actu pour l'instant.</div>}
          {items.map(item => (
            <div key={item._id} style={{ background: '#fff', border: editId === item._id ? '1.5px solid #8b1a2a' : '1px solid #dccfc8', borderRadius: 10, padding: '12px 14px', marginBottom: 10, display: 'flex', gap: 12, alignItems: 'flex-start' }}>
              {item.imageUrl && <img src={item.imageUrl} alt="" style={{ width: 60, height: 45, objectFit: 'cover', borderRadius: 6, flexShrink: 0 }} />}
              <div style={{ flex: 1, minWidth: 0 }}>
                <div style={{ fontSize: 12, fontWeight: 700, color: '#1a1010', marginBottom: 2 }}>{item.title}</div>
                <div style={{ fontSize: 12, color: CAT_COLOR[item.category] }}>{CAT_LABEL[item.category] || item.category}</div>
                <div style={{ fontSize: 12, color: '#9a8080', marginTop: 2 }}>{(item.likes?.length || 0)} j'aime · {(item.comments?.length || 0)} comm.</div>
              </div>
              <div style={{ display: 'flex', gap: 4, flexShrink: 0 }}>
                <button onClick={() => handleEdit(item)} style={{ padding: '4px 8px', borderRadius: 6, border: '1px solid #c49090', background: '#f5eeeb', color: '#8b1a2a', fontSize: 12, cursor: 'pointer' }}>Modifier</button>
                <button onClick={() => handleDelete(item._id)} style={{ padding: '4px 8px', borderRadius: 6, border: '1px solid #e0a0a0', background: '#fff', color: '#c03030', fontSize: 12, cursor: 'pointer' }}>Supprimer</button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
function SectionEnfants() {
  const CATS = [
    { key: 'touches', label: 'Ceux qui l\'ont touche', color: '#8b1a2a' },
    { key: 'enfants', label: 'Les enfants du monde entier', color: '#b05070' },
    { key: 'ses-enfants', label: 'Ses enfants', color: '#c47840' }
  ];
  const [posts, setPosts] = React.useState([]);
  const [form, setForm] = React.useState({ title: '', content: '', category: 'touches', pinned: false });
  const [file, setFile] = React.useState(null);
  const [loading, setLoading] = React.useState(false);
  const [message, setMessage] = React.useState(null);
  const fileRef = React.useRef();

  const fetchPosts = async () => {
    const res = await fetch('/api/children-posts');
    const data = await res.json();
    setPosts(data);
  };

  React.useEffect(() => { fetchPosts(); }, []);

  const handleSubmit = async () => {
    if (!file || !form.title || !form.content) return setMessage({ type: 'error', texte: 'Titre, texte et image obligatoires' });
    setLoading(true);
    const fd = new FormData();
    fd.append('image', file);
    fd.append('title', form.title);
    fd.append('content', form.content);
    fd.append('category', form.category);
    fd.append('pinned', form.pinned);
    const res = await fetch('/api/children-posts', { method: 'POST', body: fd });
    setLoading(false);
    if (res.ok) {
      setMessage({ type: 'success', texte: 'Article publie !' });
      setForm({ title: '', content: '', category: 'touches', pinned: false });
      setFile(null);
      if (fileRef.current) fileRef.current.value = '';
      fetchPosts();
    } else {
      setMessage({ type: 'error', texte: 'Erreur lors de la publication' });
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Supprimer cet article ?')) return;
    await fetch('/api/children-posts/' + id, { method: 'DELETE' });
    fetchPosts();
  };

  const handlePin = async (id) => {
    await fetch('/api/children-posts/' + id + '/pin', { method: 'PATCH' });
    fetchPosts();
  };

  return (
    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1.4fr', gap: 24, alignItems: 'start' }}>
      <div style={{ background: '#fff', border: '1px solid #dccfc8', borderRadius: 10, padding: '20px' }}>
        <div style={{ fontFamily: 'Georgia,serif', fontSize: 16, color: '#8b1a2a', marginBottom: 16 }}>Ajouter un article</div>
        {message && <div style={{ padding: '8px 12px', borderRadius: 6, marginBottom: 12, background: message.type === 'success' ? '#e8f5ee' : '#f5e8e8', color: message.type === 'success' ? '#1a5a3a' : '#8b1a2a', fontSize: 12 }}>{message.texte}</div>}
        <div style={{ marginBottom: 12 }}>
          <label style={{ display: 'block', fontSize: 12, fontWeight: 700, color: '#4a3030', marginBottom: 4 }}>Titre *</label>
          <input value={form.title} onChange={e => setForm(p => ({ ...p, title: e.target.value }))} placeholder="Titre de l'article"
            style={{ width: '100%', padding: '8px 10px', borderRadius: 6, border: '1px solid #dccfc8', fontSize: 12, boxSizing: 'border-box' }} />
        </div>
        <div style={{ marginBottom: 12 }}>
          <label style={{ display: 'block', fontSize: 12, fontWeight: 700, color: '#4a3030', marginBottom: 8 }}>Categorie *</label>
          <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap' }}>
            {CATS.map(c => (
              <button key={c.key} onClick={() => setForm(p => ({ ...p, category: c.key }))}
                style={{ padding: '5px 12px', borderRadius: 20, border: '1px solid #c49090', fontSize: 12, cursor: 'pointer', background: form.category === c.key ? c.color : '#fafaf8', color: form.category === c.key ? '#fff' : '#8b1a2a' }}>
                {c.label}
              </button>
            ))}
          </div>
        </div>
        <div style={{ marginBottom: 12 }}>
          <label style={{ display: 'block', fontSize: 12, fontWeight: 700, color: '#4a3030', marginBottom: 4 }}>Texte de l'article *</label>
          <textarea value={form.content} onChange={e => setForm(p => ({ ...p, content: e.target.value }))} rows={8} placeholder="Ecrivez l'article ici... (separez les paragraphes par des sauts de ligne)"
            style={{ width: '100%', padding: '8px 10px', borderRadius: 6, border: '1px solid #dccfc8', fontSize: 12, resize: 'vertical', boxSizing: 'border-box' }} />
        </div>
        <div style={{ marginBottom: 12 }}>
          <label style={{ display: 'block', fontSize: 12, fontWeight: 700, color: '#4a3030', marginBottom: 4 }}>Image *</label>
          <input ref={fileRef} type="file" accept="image/*" onChange={e => setFile(e.target.files[0])}
            style={{ width: '100%', padding: '8px 10px', borderRadius: 6, border: '1px solid #dccfc8', fontSize: 12, boxSizing: 'border-box' }} />
        </div>
        <div style={{ marginBottom: 16, display: 'flex', alignItems: 'center', gap: 8 }}>
          <input type="checkbox" id="pinned" checked={form.pinned} onChange={e => setForm(p => ({ ...p, pinned: e.target.checked }))} />
          <label htmlFor="pinned" style={{ fontSize: 12, color: '#4a3030', cursor: 'pointer' }}>📌 Epingler cet article</label>
        </div>
        <button onClick={handleSubmit} disabled={loading}
          style={{ width: '100%', padding: '10px', borderRadius: 6, border: 'none', background: loading ? '#c49090' : '#8b1a2a', color: '#fff', fontWeight: 700, fontSize: 13, cursor: loading ? 'not-allowed' : 'pointer' }}>
          {loading ? 'Publication...' : 'Publier'}
        </button>
      </div>

      <div>
        <div style={{ fontFamily: 'Georgia,serif', fontSize: 16, color: '#1a1010', marginBottom: 12 }}>
          Articles publies <span style={{ fontSize: 13, color: '#8b1a2a' }}>({posts.length})</span>
        </div>
        {posts.length === 0 ? (
          <div style={{ background: '#fff', border: '1px solid #dccfc8', borderRadius: 10, padding: 24, textAlign: 'center', color: '#9a8080', fontSize: 13 }}>Aucun article publie.</div>
        ) : (
          <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
            {posts.map(post => {
              const cat = CATS.find(c => c.key === post.category);
              return (
                <div key={post._id} style={{ background: '#fff', border: post.pinned ? '1.5px solid #8b1a2a' : '1px solid #dccfc8', borderRadius: 10, padding: '12px 14px', display: 'flex', gap: 12, alignItems: 'flex-start' }}>
                  <img src={post.imageUrl} alt={post.title} style={{ width: 70, height: 52, objectFit: 'cover', borderRadius: 6, flexShrink: 0 }} />
                  <div style={{ flex: 1, minWidth: 0 }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: 6, marginBottom: 2 }}>
                      {post.pinned && <span style={{ fontSize: 12 }}>📌</span>}
                      <div style={{ fontSize: 12, fontWeight: 700, color: '#1a1010', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{post.title}</div>
                    </div>
                    <div style={{ fontSize: 12, color: cat?.color, marginBottom: 2 }}>{cat?.label}</div>
                    <div style={{ fontSize: 12, color: '#9a8080', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{post.content.slice(0, 80)}...</div>
                  </div>
                  <div style={{ display: 'flex', flexDirection: 'column', gap: 4, flexShrink: 0 }}>
                    <button onClick={() => handlePin(post._id)}
                      style={{ padding: '4px 10px', borderRadius: 6, border: '1px solid #c49090', background: post.pinned ? '#f5eeeb' : '#fff', color: '#8b1a2a', fontSize: 12, cursor: 'pointer' }}>
                      {post.pinned ? 'Desepingler' : 'Epingler'}
                    </button>
                    <button onClick={() => handleDelete(post._id)}
                      style={{ padding: '4px 10px', borderRadius: 6, border: '1px solid #e0a0a0', background: '#fff', color: '#c03030', fontSize: 12, cursor: 'pointer' }}>
                      Supprimer
                    </button>
                  </div>
                </div>
              );
            })}
          </div>
        )}
      </div>
    </div>
  );
}
function SectionEntourage() {
  const CATS = [
    { key: 'famille', label: 'Sa famille', color: '#8b1a2a' },
    { key: 'amis', label: 'Ses amis', color: '#b05070' },
    { key: 'pro', label: 'Entourage pro', color: '#c47840' },
    { key: 'autres', label: 'Autres', color: '#c49090' }
  ];
  const [items, setItems] = React.useState([]);
  const [texts, setTexts] = React.useState({});
  const [form, setForm] = React.useState({ name: '', description: '', category: 'famille' });
  const [file, setFile] = React.useState(null);
  const [loading, setLoading] = React.useState(false);
  const [message, setMessage] = React.useState(null);
  const [editText, setEditText] = React.useState(null);
  const fileRef = React.useRef();

  const fetchItems = async () => {
    const res = await fetch('/api/entourage');
    const data = await res.json();
    setItems(data);
  };

  const fetchTexts = async () => {
    const res = await fetch('/api/entourage/texts');
    const data = await res.json();
    const map = {};
    data.forEach(t => { map[t.category] = t; });
    setTexts(map);
  };

  React.useEffect(() => { fetchItems(); fetchTexts(); }, []);

  const handleSubmit = async () => {
    if (!file || !form.name) return setMessage({ type: 'error', texte: 'Nom et image obligatoires' });
    setLoading(true);
    const fd = new FormData();
    fd.append('image', file);
    fd.append('name', form.name);
    fd.append('description', form.description);
    fd.append('category', form.category);
    const res = await fetch('/api/entourage', { method: 'POST', body: fd });
    setLoading(false);
    if (res.ok) {
      setMessage({ type: 'success', texte: 'Personne ajoutee !' });
      setForm({ name: '', description: '', category: 'famille' });
      setFile(null);
      if (fileRef.current) fileRef.current.value = '';
      fetchItems();
    } else {
      setMessage({ type: 'error', texte: 'Erreur lors de la publication' });
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Supprimer ?')) return;
    await fetch('/api/entourage/' + id, { method: 'DELETE' });
    fetchItems();
  };

  const handleSaveText = async (cat) => {
    const t = editText[cat] || {};
    await fetch('/api/entourage/texts/' + cat, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ title: t.title || '', text: t.text || '' })
    });
    fetchTexts();
    setEditText(null);
    setMessage({ type: 'success', texte: 'Texte sauvegarde !' });
  };

  return (
    <div>
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1.4fr', gap: 24, alignItems: 'start', marginBottom: 32 }}>
        <div style={{ background: '#fff', border: '1px solid #dccfc8', borderRadius: 10, padding: '20px' }}>
          <div style={{ fontFamily: 'Georgia,serif', fontSize: 16, color: '#8b1a2a', marginBottom: 16 }}>Ajouter une personne</div>
          {message && <div style={{ padding: '8px 12px', borderRadius: 6, marginBottom: 12, background: message.type === 'success' ? '#e8f5ee' : '#f5e8e8', color: message.type === 'success' ? '#1a5a3a' : '#8b1a2a', fontSize: 12 }}>{message.texte}</div>}
          <div style={{ marginBottom: 12 }}>
            <label style={{ display: 'block', fontSize: 12, fontWeight: 700, color: '#4a3030', marginBottom: 4 }}>Nom *</label>
            <input value={form.name} onChange={e => setForm(p => ({ ...p, name: e.target.value }))} placeholder="Ex : Elizabeth Taylor"
              style={{ width: '100%', padding: '8px 10px', borderRadius: 6, border: '1px solid #dccfc8', fontSize: 12, boxSizing: 'border-box' }} />
          </div>
          <div style={{ marginBottom: 12 }}>
            <label style={{ display: 'block', fontSize: 12, fontWeight: 700, color: '#4a3030', marginBottom: 8 }}>Categorie *</label>
            <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap' }}>
              {CATS.map(c => (
                <button key={c.key} onClick={() => setForm(p => ({ ...p, category: c.key }))}
                  style={{ padding: '5px 12px', borderRadius: 20, border: '1px solid #c49090', fontSize: 12, cursor: 'pointer', background: form.category === c.key ? c.color : '#fafaf8', color: form.category === c.key ? '#fff' : '#8b1a2a' }}>
                  {c.label}
                </button>
              ))}
            </div>
          </div>
          <div style={{ marginBottom: 12 }}>
            <label style={{ display: 'block', fontSize: 12, fontWeight: 700, color: '#4a3030', marginBottom: 4 }}>Description</label>
            <input value={form.description} onChange={e => setForm(p => ({ ...p, description: e.target.value }))} placeholder="Ex : Amie fidele depuis les annees 70"
              style={{ width: '100%', padding: '8px 10px', borderRadius: 6, border: '1px solid #dccfc8', fontSize: 12, boxSizing: 'border-box' }} />
          </div>
          <div style={{ marginBottom: 16 }}>
            <label style={{ display: 'block', fontSize: 12, fontWeight: 700, color: '#4a3030', marginBottom: 4 }}>Photo *</label>
            <input ref={fileRef} type="file" accept="image/*" onChange={e => setFile(e.target.files[0])}
              style={{ width: '100%', padding: '8px 10px', borderRadius: 6, border: '1px solid #dccfc8', fontSize: 12, boxSizing: 'border-box' }} />
          </div>
          <button onClick={handleSubmit} disabled={loading}
            style={{ width: '100%', padding: '10px', borderRadius: 6, border: 'none', background: loading ? '#c49090' : '#8b1a2a', color: '#fff', fontWeight: 700, fontSize: 13, cursor: loading ? 'not-allowed' : 'pointer' }}>
            {loading ? 'Publication...' : 'Publier'}
          </button>
        </div>

        <div>
          <div style={{ fontFamily: 'Georgia,serif', fontSize: 16, color: '#1a1010', marginBottom: 12 }}>
            Personnes publiees <span style={{ fontSize: 13, color: '#8b1a2a' }}>({items.length})</span>
          </div>
          {items.length === 0 ? (
            <div style={{ background: '#fff', border: '1px solid #dccfc8', borderRadius: 10, padding: 24, textAlign: 'center', color: '#9a8080', fontSize: 13 }}>Aucune personne publiee.</div>
          ) : (
            <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
              {items.map(item => (
                <div key={item._id} style={{ background: '#fff', border: '1px solid #dccfc8', borderRadius: 10, padding: '12px 14px', display: 'flex', gap: 12, alignItems: 'center' }}>
                  <img src={item.imageUrl} alt={item.name} style={{ width: 60, height: 60, objectFit: 'cover', borderRadius: '50%', background: '#f5eaea', flexShrink: 0 }} />
                  <div style={{ flex: 1, minWidth: 0 }}>
                    <div style={{ fontSize: 12, fontWeight: 700, color: '#1a1010', marginBottom: 2 }}>{item.name}</div>
                    <div style={{ fontSize: 12, color: '#8b1a2a' }}>{CATS.find(c => c.key === item.category) && CATS.find(c => c.key === item.category).label}</div>
                    {item.description && <div style={{ fontSize: 12, color: '#9a8080', marginTop: 1 }}>{item.description}</div>}
                  </div>
                  <button onClick={() => handleDelete(item._id)}
                    style={{ padding: '6px 12px', borderRadius: 6, border: '1px solid #e0a0a0', background: '#fff', color: '#c03030', fontSize: 12, cursor: 'pointer', flexShrink: 0 }}>
                    🗑
                  </button>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>

      <div style={{ borderTop: '1px solid #dccfc8', paddingTop: 24 }}>
        <div style={{ fontFamily: 'Georgia,serif', fontSize: 16, color: '#1a1010', marginBottom: 16 }}>Textes des encadres</div>
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16 }}>
          {CATS.map(cat => {
            const t = texts[cat.key] || {};
            const isEditing = editText && editText[cat.key] !== undefined;
            return (
              <div key={cat.key} style={{ background: '#fff', border: '1px solid #dccfc8', borderRadius: 10, padding: 16, borderLeft: '3px solid ' + cat.color }}>
                <div style={{ fontSize: 12, fontWeight: 700, color: cat.color, marginBottom: 10, textTransform: 'uppercase', letterSpacing: '0.08em' }}>{cat.label}</div>
                {isEditing ? (
                  <div>
                    <input value={editText[cat.key].title || ''} onChange={e => setEditText(p => ({ ...p, [cat.key]: { ...p[cat.key], title: e.target.value } }))}
                      placeholder="Titre de l'encadre" style={{ width: '100%', padding: '7px 10px', borderRadius: 6, border: '1px solid #dccfc8', fontSize: 12, marginBottom: 8, boxSizing: 'border-box' }} />
                    <textarea value={editText[cat.key].text || ''} onChange={e => setEditText(p => ({ ...p, [cat.key]: { ...p[cat.key], text: e.target.value } }))}
                      placeholder="Texte descriptif..." rows={4} style={{ width: '100%', padding: '7px 10px', borderRadius: 6, border: '1px solid #dccfc8', fontSize: 12, resize: 'vertical', boxSizing: 'border-box', marginBottom: 8 }} />
                    <div style={{ display: 'flex', gap: 8 }}>
                      <button onClick={() => handleSaveText(cat.key)} style={{ padding: '7px 16px', borderRadius: 6, border: 'none', background: '#8b1a2a', color: '#fff', fontSize: 12, cursor: 'pointer', fontWeight: 600 }}>Sauvegarder</button>
                      <button onClick={() => setEditText(null)} style={{ padding: '7px 16px', borderRadius: 6, border: '1px solid #c49090', background: '#fff', color: '#8b1a2a', fontSize: 12, cursor: 'pointer' }}>Annuler</button>
                    </div>
                  </div>
                ) : (
                  <div>
                    {t.title && <div style={{ fontSize: 13, fontWeight: 500, color: '#1a1010', marginBottom: 4 }}>{t.title}</div>}
                    {t.text && <div style={{ fontSize: 12, color: '#666', fontStyle: 'italic', lineHeight: 1.6, marginBottom: 8 }}>{t.text}</div>}
                    {!t.title && !t.text && <div style={{ fontSize: 12, color: '#ccc', fontStyle: 'italic', marginBottom: 8 }}>Aucun texte encore.</div>}
                    <button onClick={() => setEditText({ [cat.key]: { title: t.title || '', text: t.text || '' } })}
                      style={{ padding: '6px 14px', borderRadius: 6, border: '1px solid #c49090', background: '#f5eeeb', color: '#8b1a2a', fontSize: 12, cursor: 'pointer' }}>
                      Modifier
                    </button>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}
function SectionArtGraphique() {
  const [items, setItems] = React.useState([]);
  const [form, setForm] = React.useState({ title: '', description: '', category: 'dessins' });
  const [file, setFile] = React.useState(null);
  const [loading, setLoading] = React.useState(false);
  const [message, setMessage] = React.useState(null);
  const fileRef = React.useRef();

  const fetchItems = async () => {
    try {
      const res = await fetch('/api/graphic-art');
      const data = await res.json();
      setItems(data);
    } catch(e) { console.error(e); }
  };

  React.useEffect(() => { fetchItems(); }, []);

  const handleSubmit = async () => {
    if (!file || !form.title) return setMessage({ type: 'error', texte: 'Titre et image obligatoires' });
    setLoading(true);
    const fd = new FormData();
    fd.append('image', file);
    fd.append('title', form.title);
    fd.append('description', form.description);
    fd.append('category', form.category);
    const token = sessionStorage.getItem('mjadmin_token') || '';
    const res = await fetch('/api/graphic-art', {
      method: 'POST',
      headers: { Authorization: 'Bearer ' + token },
      body: fd
    });
    setLoading(false);
    if (res.ok) {
      setMessage({ type: 'success', texte: 'Oeuvre publiée !' });
      setForm({ title: '', description: '', category: 'dessins' });
      setFile(null);
      if (fileRef.current) fileRef.current.value = '';
      fetchItems();
    } else {
      setMessage({ type: 'error', texte: 'Erreur lors de la publication' });
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Supprimer cette oeuvre ?')) return;
    const token = sessionStorage.getItem('mjadmin_token') || '';
    await fetch('/api/graphic-art/' + id, {
      method: 'DELETE',
      headers: { Authorization: 'Bearer ' + token }
    });
    fetchItems();
  };

  const catLabel = { dessins: 'Ses dessins', lettres: 'Ses lettres', mots: 'Ses petits mots' };
  const catDot = { dessins: '#8b1a2a', lettres: '#b05070', mots: '#e8a0a0' };

  return (
    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1.4fr', gap: 24, alignItems: 'start' }}>
      <div style={{ background: '#fff', border: '1px solid #dccfc8', borderRadius: 10, padding: '20px' }}>
        <div style={{ fontFamily: 'Georgia,serif', fontSize: 16, color: '#8b1a2a', marginBottom: 16 }}>Ajouter une oeuvre</div>
        {message && <div style={{ padding: '8px 12px', borderRadius: 6, marginBottom: 12, background: message.type === 'success' ? '#e8f5ee' : '#f5e8e8', color: message.type === 'success' ? '#1a5a3a' : '#8b1a2a', fontSize: 12 }}>{message.texte}</div>}
        <div style={{ marginBottom: 12 }}>
          <label style={{ display: 'block', fontSize: 12, fontWeight: 700, color: '#4a3030', marginBottom: 4 }}>Titre *</label>
          <input value={form.title} onChange={e => setForm(p => ({ ...p, title: e.target.value }))} placeholder="Ex : Autoportrait au crayon, 1983"
            style={{ width: '100%', padding: '8px 10px', borderRadius: 6, border: '1px solid #dccfc8', fontSize: 12, boxSizing: 'border-box' }} />
        </div>
        <div style={{ marginBottom: 12 }}>
          <label style={{ display: 'block', fontSize: 12, fontWeight: 700, color: '#4a3030', marginBottom: 8 }}>Categorie *</label>
          <div style={{ display: 'flex', gap: 6 }}>
            {[{ k: 'dessins', l: 'Dessins' }, { k: 'lettres', l: 'Lettres' }, { k: 'mots', l: 'Petits mots' }].map(c => (
              <button key={c.k} onClick={() => setForm(p => ({ ...p, category: c.k }))}
                style={{ padding: '5px 12px', borderRadius: 20, border: '1px solid #c49090', fontSize: 12, cursor: 'pointer', background: form.category === c.k ? '#8b1a2a' : '#fafaf8', color: form.category === c.k ? '#fff' : '#8b1a2a' }}>
                {c.l}
              </button>
            ))}
          </div>
        </div>
        <div style={{ marginBottom: 12 }}>
          <label style={{ display: 'block', fontSize: 12, fontWeight: 700, color: '#4a3030', marginBottom: 4 }}>Description</label>
          <textarea value={form.description} onChange={e => setForm(p => ({ ...p, description: e.target.value }))} rows={2} placeholder="Medium, date, collection..."
            style={{ width: '100%', padding: '8px 10px', borderRadius: 6, border: '1px solid #dccfc8', fontSize: 12, resize: 'vertical', boxSizing: 'border-box' }} />
        </div>
        <div style={{ marginBottom: 16 }}>
          <label style={{ display: 'block', fontSize: 12, fontWeight: 700, color: '#4a3030', marginBottom: 4 }}>Image *</label>
          <input ref={fileRef} type="file" accept="image/*" onChange={e => setFile(e.target.files[0])}
            style={{ width: '100%', padding: '8px 10px', borderRadius: 6, border: '1px solid #dccfc8', fontSize: 12, boxSizing: 'border-box' }} />
        </div>
        <button onClick={handleSubmit} disabled={loading}
          style={{ width: '100%', padding: '10px', borderRadius: 6, border: 'none', background: loading ? '#c49090' : '#8b1a2a', color: '#fff', fontWeight: 700, fontSize: 13, cursor: loading ? 'not-allowed' : 'pointer' }}>
          {loading ? 'Publication...' : 'Publier'}
        </button>
      </div>

      <div>
        <div style={{ fontFamily: 'Georgia,serif', fontSize: 16, color: '#1a1010', marginBottom: 12 }}>
          Oeuvres publiees <span style={{ fontSize: 13, color: '#8b1a2a' }}>({items.length})</span>
        </div>
        {items.length === 0 ? (
          <div style={{ background: '#fff', border: '1px solid #dccfc8', borderRadius: 10, padding: 24, textAlign: 'center', color: '#9a8080', fontSize: 13 }}>Aucune oeuvre publiee.</div>
        ) : (
          <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
            {items.map(item => (
              <div key={item._id} style={{ background: '#fff', border: '1px solid #dccfc8', borderRadius: 10, padding: '12px 14px', display: 'flex', gap: 12, alignItems: 'center' }}>
                <img src={item.imageUrl} alt={item.title} style={{ width: 80, height: 60, objectFit: 'cover', borderRadius: 6, background: '#f5eaea', flexShrink: 0 }} />
                <div style={{ flex: 1, minWidth: 0 }}>
                  <div style={{ fontSize: 12, fontWeight: 700, color: '#1a1010', marginBottom: 3, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{item.title}</div>
                  <div style={{ fontSize: 12, color: '#8b1a2a', display: 'flex', alignItems: 'center', gap: 4 }}>
                    <span style={{ width: 5, height: 5, borderRadius: '50%', background: catDot[item.category], display: 'inline-block' }}></span>
                    {catLabel[item.category]}
                  </div>
                  {item.description && <div style={{ fontSize: 12, color: '#9a8080', marginTop: 2 }}>{item.description}</div>}
                </div>
                <button onClick={() => handleDelete(item._id)}
                  style={{ padding: '6px 12px', borderRadius: 6, border: '1px solid #e0a0a0', background: '#fff', color: '#c03030', fontSize: 12, cursor: 'pointer', flexShrink: 0 }}>
                  🗑
                </button>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}

function SectionMembres() {
  const [users, setUsers] = React.useState([]);
  const [q, setQ] = React.useState('');
  const [message, setMessage] = React.useState(null);
  const [loading, setLoading] = React.useState(false);
  const token = localStorage.getItem('mjtoken') || '';

  const fetchUsers = async () => {
    setLoading(true);
    try {
      const res = await fetch('/api/admin/users', { headers: { Authorization: 'Bearer ' + token } });
      if (!res.ok) {
        setMessage({ type: 'error', texte: res.status === 403 ? 'Acces refuse : votre compte doit etre admin.' : (res.status === 401 ? 'Connectez-vous au site avec votre compte admin.' : 'Erreur de chargement.') });
        setUsers([]);
      } else {
        const data = await res.json();
        if (Array.isArray(data)) { setUsers(data); setMessage(null); }
      }
    } catch { setMessage({ type: 'error', texte: 'Erreur reseau.' }); }
    setLoading(false);
  };

  React.useEffect(() => { fetchUsers(); }, []);

  const toggleBan = async (u) => {
    const banned = !u.banned;
    let reason = '';
    if (banned) { reason = window.prompt('Raison du bannissement (optionnel) :', '') || ''; }
    else if (!window.confirm('Reactiver ce compte ?')) return;
    try {
      const res = await fetch('/api/admin/user/' + u._id + '/ban', {
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json', Authorization: 'Bearer ' + token },
        body: JSON.stringify({ banned, reason })
      });
      if (res.ok) { setMessage({ type: 'success', texte: banned ? 'Membre banni.' : 'Membre reactive.' }); fetchUsers(); }
      else { const e = await res.json().catch(() => ({})); setMessage({ type: 'error', texte: e.message || 'Action refusee.' }); }
    } catch { setMessage({ type: 'error', texte: 'Erreur reseau.' }); }
  };

  const filtered = users.filter(u => {
    const t = q.toLowerCase();
    return !t || (u.username || '').toLowerCase().includes(t) || (u.email || '').toLowerCase().includes(t);
  });

  return (
    <div>
      {message && <div style={{ padding: '8px 12px', borderRadius: 6, marginBottom: 12, background: message.type === 'success' ? '#e8f5ee' : '#f5e8e8', color: message.type === 'success' ? '#1a5a3a' : '#8b1a2a', fontSize: 12 }}>{message.texte}</div>}
      <div style={{ display: 'flex', gap: 10, alignItems: 'center', marginBottom: 16 }}>
        <input value={q} onChange={e => setQ(e.target.value)} placeholder="Rechercher par pseudo ou email..."
          style={{ flex: 1, padding: '8px 12px', borderRadius: 8, border: '1px solid #dccfc8', fontSize: 13, boxSizing: 'border-box' }} />
        <button onClick={fetchUsers} style={{ padding: '8px 14px', borderRadius: 6, border: '1px solid #c49090', background: '#f5eeeb', color: '#8b1a2a', fontSize: 12, cursor: 'pointer' }}>Actualiser</button>
      </div>
      <div style={{ fontSize: 12, color: '#9a8080', marginBottom: 10 }}>{filtered.length} membre(s)</div>
      {loading ? (
        <div style={{ textAlign: 'center', padding: 40, color: '#9a8080' }}>Chargement...</div>
      ) : (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
          {filtered.map(u => (
            <div key={u._id} style={{ background: '#fff', border: u.banned ? '1px solid #c03030' : '1px solid #dccfc8', borderRadius: 10, padding: '12px 14px', display: 'flex', gap: 12, alignItems: 'center' }}>
              <div style={{ width: 40, height: 40, borderRadius: '50%', background: '#e8c0c8', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 13, fontWeight: 700, color: '#8b1a2a', overflow: 'hidden', flexShrink: 0 }}>
                {u.photo ? <img src={u.photo} alt="" style={{ width: '100%', height: '100%', objectFit: 'cover' }} /> : (u.username || 'U').slice(0, 2).toUpperCase()}
              </div>
              <div style={{ flex: 1, minWidth: 0 }}>
                <div style={{ fontSize: 13, fontWeight: 700, color: '#1a1010' }}>
                  {u.username}
                  {u.role === 'admin' && <span style={{ fontSize: 12, background: '#1a1010', color: '#fff', padding: '1px 6px', borderRadius: 8, marginLeft: 6 }}>ADMIN</span>}
                  {u.banned && <span style={{ fontSize: 12, background: '#c03030', color: '#fff', padding: '1px 6px', borderRadius: 8, marginLeft: 6 }}>BANNI</span>}
                </div>
                <div style={{ fontSize: 12, color: '#9a8080', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{u.email} {u.country ? '\u00b7 ' + u.country : ''}</div>
                {u.banned && u.banReason && <div style={{ fontSize: 12, color: '#c03030', marginTop: 2 }}>Raison : {u.banReason}</div>}
              </div>
              {u.role !== 'admin' && (
                <button onClick={() => toggleBan(u)} style={{ padding: '6px 14px', borderRadius: 6, border: u.banned ? 'none' : '1px solid #e0a0a0', background: u.banned ? '#1a6a30' : '#fff', color: u.banned ? '#fff' : '#c03030', fontSize: 12, fontWeight: 700, cursor: 'pointer', flexShrink: 0 }}>
                  {u.banned ? 'R\u00e9activer' : 'Bannir'}
                </button>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

function SectionStats() {
  const [data, setData] = React.useState(null);
  const [message, setMessage] = React.useState(null);
  const token = localStorage.getItem('mjtoken') || '';

  React.useEffect(() => {
    (async () => {
      try {
        const res = await fetch('/api/admin/stats', { headers: { Authorization: 'Bearer ' + token } });
        if (!res.ok) { setMessage(res.status === 403 ? 'Acces refuse : compte administrateur requis.' : 'Erreur de chargement.'); return; }
        setData(await res.json());
      } catch { setMessage('Erreur reseau.'); }
    })();
  }, []);

  if (message) return <div style={{ padding: 20, color: '#8b1a2a', fontSize: 13 }}>{message}</div>;
  if (!data) return <div style={{ textAlign: 'center', padding: 40, color: '#9a8080', fontSize: 13 }}>Chargement...</div>;

  const maxMonth = Math.max(1, ...data.signupsByMonth.map(m => m.n));
  const maxCountry = Math.max(1, ...data.byCountry.map(c => c.n));
  const maxAge = Math.max(1, ...data.byAge.map(a => a.n));
  const maxSexe = Math.max(1, ...data.bySexe.map(x => x.n));
  const activeByDay = data.activeByDay || [];
  const maxActive = Math.max(1, ...activeByDay.map(d => d.n));
  const hasActivity = activeByDay.some(d => d.n > 0);
  const onlineByCountry = data.onlineByCountry || [];
  const card = { background: '#fff', border: '1px solid #dccfc8', borderRadius: 10, padding: 20 };
  const ttl = { fontFamily: 'Georgia,serif', fontSize: 16, color: '#8b1a2a', marginBottom: 16 };
  const pct = n => data.total ? Math.round(n / data.total * 100) : 0;
  const labelSexe = x => /^h/i.test(x) ? 'Hommes' : /^f/i.test(x) ? 'Femmes' : x;
  const flag = c => /^[a-zA-Z]{2}$/.test(c) ? String.fromCodePoint(...[...c.toUpperCase()].map(ch => 127397 + ch.charCodeAt(0))) : '';

  const barRow = (label, n, max, color) => (
    <div key={label} style={{ marginBottom: 8 }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: 13, color: '#4a3030', marginBottom: 3 }}>
        <span>{label}</span><span>{n} ({pct(n)}%)</span>
      </div>
      <div style={{ height: 10, background: '#f5eeeb', borderRadius: 5, overflow: 'hidden' }}>
        <div style={{ height: '100%', width: (n / max * 100) + '%', background: color }}></div>
      </div>
    </div>
  );

  const cards = [
    { l: 'En ligne', n: data.online || 0, c: '#1a6a30' },
    { l: 'Membres', n: data.total, c: '#8b1a2a' },
    { l: 'Bannis', n: data.banned, c: '#8b1a2a' },
    { l: 'Pays', n: data.byCountry.length, c: '#8b1a2a' }
  ];

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 20 }}>
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4,1fr)', gap: 16 }}>
        {cards.map(s => (
          <div key={s.l} style={{ ...card, textAlign: 'center' }}>
            <div style={{ fontSize: 30, fontWeight: 500, color: s.c, fontFamily: 'Georgia,serif' }}>{s.n}</div>
            <div style={{ fontSize: 13, color: '#9a8080', marginTop: 4 }}>{s.l}</div>
          </div>
        ))}
      </div>

      <div style={card}>
        <div style={ttl}>Membres en ligne, par pays</div>
        {onlineByCountry.length > 0 ? (
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8 }}>
            {onlineByCountry.map(o => (
              <div key={o.country} style={{ display: 'flex', alignItems: 'center', gap: 6, padding: '6px 14px', background: '#eef6ef', border: '1px solid #cfe3d0', borderRadius: 20, fontSize: 13, color: '#1a5a3a' }}>
                <span>{flag(o.country)} {o.country}</span>
                <strong>{o.n}</strong>
              </div>
            ))}
          </div>
        ) : (
          <div style={{ fontSize: 13, color: '#9a8080' }}>Aucun membre en ligne pour le moment.</div>
        )}
        <div style={{ fontSize: 12, color: '#9a8080', fontStyle: 'italic', marginTop: 10 }}>Pays declare dans le profil (pas la geolocalisation reelle).</div>
      </div>

      <div style={card}>
        <div style={ttl}>Membres actifs par jour (30 derniers jours)</div>
        <div style={{ display: 'flex', alignItems: 'flex-end', gap: 3, height: 150 }}>
          {activeByDay.map((d, i) => (
            <div key={i} title={d.label + ' : ' + d.n} style={{ flex: 1, background: d.n > 0 ? '#1a6a30' : '#e8e0db', borderRadius: '3px 3px 0 0', height: Math.max(2, d.n / maxActive * 120) + 'px' }}></div>
          ))}
        </div>
        <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: 12, color: '#9a8080', marginTop: 6 }}>
          <span>{activeByDay.length ? activeByDay[0].label : ''}</span>
          <span>{activeByDay.length ? activeByDay[activeByDay.length - 1].label : ''}</span>
        </div>
        <div style={{ fontSize: 13, color: '#4a3030', marginTop: 12 }}>
          Temps d'utilisation moyen par session : <strong>{data.avgSessionMin != null ? data.avgSessionMin + ' min' : 'pas encore de donnees'}</strong>
        </div>
        {!hasActivity && <div style={{ fontSize: 12, color: '#9a8080', fontStyle: 'italic', marginTop: 6 }}>Ces deux donnees se remplissent a partir de maintenant.</div>}
      </div>

      <div style={card}>
        <div style={ttl}>Inscriptions (12 derniers mois)</div>
        <div style={{ display: 'flex', alignItems: 'flex-end', gap: 6, height: 170 }}>
          {data.signupsByMonth.map((m, i) => (
            <div key={i} style={{ flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'flex-end' }}>
              <div style={{ fontSize: 12, color: '#6a5050', marginBottom: 2 }}>{m.n || ''}</div>
              <div title={m.label} style={{ width: '70%', background: '#8b1a2a', borderRadius: '4px 4px 0 0', height: (m.n / maxMonth * 110) + 'px', minHeight: m.n > 0 ? 2 : 0 }}></div>
              <div style={{ fontSize: 12, color: '#9a8080', marginTop: 4 }}>{m.label}</div>
            </div>
          ))}
        </div>
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16 }}>
        <div style={card}>
          <div style={ttl}>Repartition par pays</div>
          {data.byCountry.slice(0, 12).map(c => barRow(c.country, c.n, maxCountry, '#8b1a2a'))}
        </div>
        <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
          <div style={card}>
            <div style={ttl}>Hommes / Femmes</div>
            {data.bySexe.map(x => barRow(labelSexe(x.sexe), x.n, maxSexe, /^f/i.test(x.sexe) ? '#b05070' : '#5a6b8c'))}
          </div>
          <div style={card}>
            <div style={ttl}>Tranches d'age</div>
            {data.byAge.map(ag => barRow(ag.range, ag.n, maxAge, '#7a6a8c'))}
          </div>
        </div>
      </div>

      <div style={{ fontSize: 13, color: '#9a8080', fontStyle: 'italic', lineHeight: 1.5 }}>
        La provenance des visiteurs (Google, TikTok...) n'est pas encore suivie.
      </div>
    </div>
  );
}

function SectionSignalements() {
  const [reports, setReports] = React.useState([]);
  const [loading, setLoading] = React.useState(true);
  const [message, setMessage] = React.useState(null);
  const token = localStorage.getItem('mjtoken') || '';

  const load = async () => {
    setLoading(true);
    try {
      const res = await fetch('/api/reports', { headers: { Authorization: 'Bearer ' + token } });
      if (res.ok) setReports(await res.json());
      else setMessage({ type: 'error', texte: 'Acces refuse ou erreur de chargement.' });
    } catch {
      setMessage({ type: 'error', texte: 'Erreur de chargement.' });
    }
    setLoading(false);
  };

  React.useEffect(() => { load(); }, []);

  const updateStatus = async (id, status) => {
    try {
      const res = await fetch('/api/reports/' + id, {
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json', Authorization: 'Bearer ' + token },
        body: JSON.stringify({ status })
      });
      if (res.ok) {
        const updated = await res.json();
        setReports(prev => prev.map(r => r._id === id ? updated : r));
      }
    } catch {}
  };

  const deleteTarget = async (r) => {
    if (!window.confirm('Supprimer définitivement ce commentaire ?')) return;
    try {
      const res = await fetch('/api/reports/' + r._id + '/target', { method: 'DELETE', headers: { Authorization: 'Bearer ' + token } });
      if (res.ok) {
        const updated = await res.json();
        setReports(prev => prev.map(x => x._id === r._id ? updated : x));
      }
    } catch {}
  };

  const banUser = async (r, ban) => {
    if (!window.confirm(ban ? 'Bannir ce membre ?' : 'Reactiver ce membre ?')) return;
    try {
      const res = await fetch('/api/reports/' + r._id + (ban ? '/ban' : '/unban'), { method: 'PATCH', headers: { Authorization: 'Bearer ' + token } });
      if (res.ok) {
        setMessage({ type: 'success', texte: ban ? 'Membre banni.' : 'Membre reactive.' });
        setReports(prev => prev.map(x => x._id === r._id ? { ...x, targetBanned: ban, status: ban ? 'traite' : x.status } : x));
      } else {
        const d = await res.json().catch(() => ({}));
        setMessage({ type: 'error', texte: d.message || 'Action impossible.' });
      }
    } catch {
      setMessage({ type: 'error', texte: 'Erreur reseau.' });
    }
  };

  const typeLabels = { membre: 'Membre', commentaire: 'Commentaire', discussion: 'Discussion', temoignage: 'Temoignage' };
  const statusStyle = {
    nouveau: { bg: '#fff3f0', col: '#c03030', txt: 'Nouveau' },
    traite: { bg: '#e8f5ee', col: '#1a5a3a', txt: 'Traite' },
    rejete: { bg: '#f1efe8', col: '#6a5050', txt: 'Rejete' }
  };

  return (
    <div>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 16 }}>
        <div style={{ fontFamily: 'Georgia,serif', fontSize: 18, color: '#1a1010' }}>Signalements</div>
        <button onClick={load} style={{ background: '#f5eeeb', color: '#8b1a2a', border: '1px solid #c49090', borderRadius: 6, padding: '5px 14px', fontSize: 12, cursor: 'pointer' }}>Actualiser</button>
      </div>

      {message && <div style={{ padding: '8px 12px', borderRadius: 6, marginBottom: 12, background: message.type === 'success' ? '#e8f5ee' : '#f5e8e8', color: message.type === 'success' ? '#1a5a3a' : '#8b1a2a', fontSize: 12 }}>{message.texte}</div>}

      {loading ? (
        <div style={{ textAlign: 'center', padding: 40, color: '#9a8080', fontSize: 13 }}>Chargement...</div>
      ) : reports.length === 0 ? (
        <div style={{ textAlign: 'center', padding: 40, color: '#9a8080', fontSize: 13 }}>Aucun signalement.</div>
      ) : (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
          {reports.map(r => {
            const st = statusStyle[r.status] || statusStyle.nouveau;
            return (
              <div key={r._id} style={{ background: '#fff', border: '1px solid #dccfc8', borderRadius: 10, padding: '14px 16px' }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 8, flexWrap: 'wrap' }}>
                  <span style={{ fontSize: 12, fontWeight: 500, color: '#1a1010' }}>{typeLabels[r.targetType] || r.targetType}</span>
                  <span style={{ fontSize: 12, background: st.bg, color: st.col, padding: '2px 9px', borderRadius: 10 }}>{st.txt}</span>
                  <span style={{ marginLeft: 'auto', fontSize: 12, color: '#9a8080' }}>{new Date(r.createdAt).toLocaleString('fr-FR')}</span>
                </div>
                {r.targetLabel && <div style={{ fontSize: 12, color: '#4a3030', background: '#fafaf8', borderRadius: 6, padding: '8px 10px', marginBottom: 8, fontStyle: 'italic' }}>{r.targetLabel}</div>}
                {r.targetType === 'discussion' && Array.isArray(r.snapshot) && r.snapshot.length > 0 && (
                  <div style={{ background: '#fafaf8', border: '1px solid #eedede', borderRadius: 8, padding: '8px 10px', marginBottom: 8 }}>
                    <div style={{ fontSize: 12, color: '#9a8080', marginBottom: 6 }}>Extrait fige ({r.snapshot.length} messages)</div>
                    {r.snapshot.map((m, i) => (
                      <div key={i} style={{ fontSize: 12, color: '#1a1010', marginBottom: 4, lineHeight: 1.4 }}>
                        <span style={{ fontWeight: 500, color: '#8b1a2a' }}>{m.from || 'Membre'} : </span>{m.text || ''}
                        {m.image && <img src={m.image} alt="" style={{ display: 'block', maxWidth: 160, borderRadius: 6, marginTop: 4 }} />}
                      </div>
                    ))}
                  </div>
                )}
                <div style={{ fontSize: 12, color: '#6a5050', marginBottom: 10 }}>Signale par {r.reporterName || 'Membre'}</div>
                <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
                  {r.targetType === 'commentaire' && r.status !== 'traite' && <button onClick={() => deleteTarget(r)} style={{ background: '#8b1a2a', color: '#fff', border: 'none', borderRadius: 6, padding: '6px 16px', fontSize: 12, cursor: 'pointer' }}>Supprimer le commentaire</button>}
                  {(r.banUserId || r.targetType === 'membre') && !r.targetBanned && <button onClick={() => banUser(r, true)} style={{ background: '#8b1a2a', color: '#fff', border: 'none', borderRadius: 6, padding: '6px 16px', fontSize: 12, cursor: 'pointer' }}>Bannir le membre</button>}
                  {(r.banUserId || r.targetType === 'membre') && r.targetBanned && <button onClick={() => banUser(r, false)} style={{ background: '#fff', color: '#8b1a2a', border: '1px solid #c49090', borderRadius: 6, padding: '6px 16px', fontSize: 12, cursor: 'pointer' }}>Débannir</button>}
                  {r.status !== 'traite' && <button onClick={() => updateStatus(r._id, 'traite')} style={{ background: '#1a6a30', color: '#fff', border: 'none', borderRadius: 6, padding: '6px 16px', fontSize: 12, cursor: 'pointer' }}>Traite</button>}
                  {r.status !== 'rejete' && <button onClick={() => updateStatus(r._id, 'rejete')} style={{ background: '#fff', color: '#c03030', border: '1px solid #e0a0a0', borderRadius: 6, padding: '6px 16px', fontSize: 12, cursor: 'pointer' }}>Rejeter</button>}
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}

function SectionSoumissions() {
  const TYPE_LABEL = { actualite: 'Une actualite', info: 'Une info / autre' };
  const TYPE_COLOR = { actualite: '#8b1a2a', info: '#b05070' };
  const [items, setItems] = React.useState([]);
  const token = localStorage.getItem('mjtoken');

  const fetchItems = async () => {
    const res = await fetch('/api/submissions', { headers: { Authorization: 'Bearer ' + token } });
    const data = await res.json();
    if (Array.isArray(data)) setItems(data);
  };
  React.useEffect(() => { fetchItems(); }, []);

  const toggleDone = async (id) => {
    await fetch('/api/submissions/' + id + '/done', { method: 'PATCH', headers: { Authorization: 'Bearer ' + token } });
    fetchItems();
  };
  const handleDelete = async (id) => {
    if (!window.confirm('Supprimer cette soumission ?')) return;
    await fetch('/api/submissions/' + id, { method: 'DELETE', headers: { Authorization: 'Bearer ' + token } });
    fetchItems();
  };

  const fmt = d => { try { return new Date(d).toLocaleDateString('fr-FR'); } catch { return ''; } };

  return (
    <div>
      <div style={{ fontFamily: 'Georgia,serif', fontSize: 16, color: '#1a1010', marginBottom: 16 }}>Soumissions ({items.length})</div>
      {items.length === 0 && <div style={{ fontSize: 12, color: '#9a8080', fontStyle: 'italic' }}>Aucune soumission pour l'instant.</div>}
      {items.map(item => (
        <div key={item._id} style={{ background: item.status === 'fait' ? '#f3f3f1' : '#fff', border: item.status === 'fait' ? '1px solid #dccfc8' : '1.5px solid #8b1a2a', borderRadius: 10, padding: '14px 16px', marginBottom: 12, opacity: item.status === 'fait' ? 0.7 : 1 }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: 12 }}>
            <div style={{ flex: 1, minWidth: 0 }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 6, flexWrap: 'wrap' }}>
                <span style={{ fontSize: 12, fontWeight: 700, color: '#fff', background: TYPE_COLOR[item.type] || '#8b1a2a', padding: '2px 10px', borderRadius: 12 }}>{TYPE_LABEL[item.type] || item.type}</span>
                {item.status !== 'fait' && <span style={{ fontSize: 12, fontWeight: 700, color: '#8b1a2a' }}>NOUVEAU</span>}
                <span style={{ fontSize: 12, color: '#9a8080' }}>{fmt(item.createdAt)}</span>
              </div>
              <div style={{ fontSize: 13, fontWeight: 700, color: '#1a1010', marginBottom: 2 }}>{item.authorName || 'Anonyme'}{item.authorCountry ? ' — ' + item.authorCountry : ''}</div>
              {item.eventName && <div style={{ fontSize: 12, color: '#4a3030', marginBottom: 2 }}>Titre : {item.eventName}</div>}
              {(item.city || item.year) && <div style={{ fontSize: 12, color: '#9a8080', marginBottom: 2 }}>{item.city} {item.year}</div>}
              {item.content && <div style={{ fontSize: 13, color: '#4a3030', lineHeight: 1.6, marginTop: 6, whiteSpace: 'pre-wrap' }}>{item.content}</div>}
              {(item.photos?.length > 0) && (
                <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap', marginTop: 8 }}>
                  {item.photos.map((p, i) => <a key={i} href={p} target="_blank" rel="noreferrer"><img src={p} alt="" style={{ width: 60, height: 60, objectFit: 'cover', borderRadius: 6, border: '1px solid #dccfc8' }} /></a>)}
                </div>
              )}
              {item.videoUrl && <div style={{ fontSize: 12, marginTop: 6 }}><a href={item.videoUrl} target="_blank" rel="noreferrer" style={{ color: '#8b1a2a' }}>Lien vidéo</a></div>}
            </div>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 6, flexShrink: 0 }}>
              <button onClick={() => toggleDone(item._id)} style={{ padding: '6px 14px', borderRadius: 6, border: 'none', background: item.status === 'fait' ? '#9a8080' : '#1a6a30', color: '#fff', fontSize: 12, fontWeight: 700, cursor: 'pointer' }}>{item.status === 'fait' ? 'A traiter' : 'Fait'}</button>
              <button onClick={() => handleDelete(item._id)} style={{ padding: '6px 14px', borderRadius: 6, border: '1px solid #e0a0a0', background: '#fff', color: '#c03030', fontSize: 12, cursor: 'pointer' }}>Supprimer</button>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}
function SectionAccueil() {
  const token = localStorage.getItem('mjtoken');
  const [doc, setDoc] = React.useState(null);
  const [mTitle, setMTitle] = React.useState('');
  const [mText, setMText] = React.useState('');
  const [mLink, setMLink] = React.useState('');
  const [mActive, setMActive] = React.useState(true);
  const [mFile, setMFile] = React.useState(null);
  const [mAudio, setMAudio] = React.useState(null);
  const audioRef = React.useRef();
  const [soundColor, setSoundColor] = React.useState('#8b1a2a');
  const [soundFile, setSoundFile] = React.useState(null);
  const soundRef = React.useRef();
  const addSound = async () => {
    if (!soundFile) { setMsg({ t: 'err', x: 'Choisis un fichier audio' }); return; }
    setSaving(true); setMsg(null);
    const fd = new FormData();
    fd.append('audio', soundFile); fd.append('color', soundColor);
    const res = await fetch('/api/home-content/media/sound', { method: 'POST', headers: { Authorization: 'Bearer ' + token }, body: fd });
    setSaving(false);
    if (res.ok) { setMsg({ t: 'ok', x: 'Son ajouté !' }); setSoundFile(null); if (soundRef.current) soundRef.current.value = ''; load(); }
    else { const e = await res.json().catch(() => ({})); setMsg({ t: 'err', x: e.error || 'Erreur ajout son' }); }
  };
  const deleteSound = async (i) => {
    if (!window.confirm('Supprimer ce son ?')) return;
    const res = await fetch('/api/home-content/media/sound/' + i, { method: 'DELETE', headers: { Authorization: 'Bearer ' + token } });
    if (res.ok) load();
  };
  const [iFile, setIFile] = React.useState(null);
  const iFileRef = React.useRef();
  const [iTitle, setITitle] = React.useState('');
  const [iText, setIText] = React.useState('');
  const [iLink, setILink] = React.useState('');
  const [iActive, setIActive] = React.useState(true);
  const [msg, setMsg] = React.useState(null);
  const [saving, setSaving] = React.useState(false);
  const fileRef = React.useRef();
  const [polls, setPolls] = React.useState([]);
  const [pQuestion, setPQuestion] = React.useState('');
  const [pOptions, setPOptions] = React.useState(['', '']);
  const loadPolls = async () => {
    const res = await fetch('/api/polls', { headers: { Authorization: 'Bearer ' + token } });
    const d = await res.json();
    if (Array.isArray(d)) setPolls(d);
  };
  React.useEffect(() => { loadPolls(); }, []);
  const createPoll = async () => {
    const opts = pOptions.filter(o => o.trim());
    if (!pQuestion.trim() || opts.length < 2) { setMsg({ t: 'err', x: 'Question + 2 options minimum' }); return; }
    const res = await fetch('/api/polls', { method: 'POST', headers: { 'Content-Type': 'application/json', Authorization: 'Bearer ' + token }, body: JSON.stringify({ question: pQuestion, options: opts }) });
    if (res.ok) { setMsg({ t: 'ok', x: 'Sondage créé !' }); setPQuestion(''); setPOptions(['', '']); loadPolls(); }
    else setMsg({ t: 'err', x: 'Erreur création sondage' });
  };
  const activatePoll = async (id, on) => {
    await fetch('/api/polls/' + id + (on ? '/activate' : '/deactivate'), { method: 'PATCH', headers: { Authorization: 'Bearer ' + token } });
    loadPolls();
  };
  const deletePoll = async (id) => {
    if (!window.confirm('Supprimer ce sondage ?')) return;
    await fetch('/api/polls/' + id, { method: 'DELETE', headers: { Authorization: 'Bearer ' + token } });
    loadPolls();
  };

  const load = async () => {
    const res = await fetch('/api/home-content');
    const d = await res.json();
    setDoc(d);
    if (d?.media) { setMTitle(d.media.title || ''); setMText(d.media.text || ''); setMLink(d.media.link || ''); setMActive(d.media.active !== false); }
    if (d?.info) { setITitle(d.info.title || ''); setIText(d.info.text || ''); setILink(d.info.link || ''); setIActive(d.info.active !== false); }
  };
  React.useEffect(() => { load(); }, []);

  const saveMedia = async () => {
    setSaving(true); setMsg(null);
    const fd = new FormData();
    fd.append('title', mTitle); fd.append('text', mText); fd.append('link', mLink); fd.append('active', mActive);
    if (mFile) fd.append('media', mFile);
    if (mAudio) fd.append('audio', mAudio);
    const res = await fetch('/api/home-content/media', { method: 'PUT', headers: { Authorization: 'Bearer ' + token }, body: fd });
    setSaving(false);
    if (res.ok) { setMsg({ t: 'ok', x: 'Média enregistré !' }); setMFile(null); setMAudio(null); if (fileRef.current) fileRef.current.value = ''; if (audioRef.current) audioRef.current.value = ''; load(); }
    else setMsg({ t: 'err', x: 'Erreur média' });
  };
  const removeMediaAudio = async () => {
    if (!window.confirm('Supprimer le son principal du média ?')) return;
    setSaving(true); setMsg(null);
    const fd = new FormData();
    fd.append('removeAudio', 'true');
    const res = await fetch('/api/home-content/media', { method: 'PUT', headers: { Authorization: 'Bearer ' + token }, body: fd });
    setSaving(false);
    if (res.ok) { setMsg({ t: 'ok', x: 'Son supprimé !' }); load(); }
    else setMsg({ t: 'err', x: 'Erreur suppression son' });
  };
  const saveInfo = async () => {
    setSaving(true); setMsg(null);
    const fd = new FormData();
    fd.append('title', iTitle); fd.append('text', iText); fd.append('link', iLink); fd.append('active', iActive);
    if (iFile) fd.append('image', iFile);
    const res = await fetch('/api/home-content/info', { method: 'PUT', headers: { Authorization: 'Bearer ' + token }, body: fd });
    setSaving(false);
    if (res.ok) { setMsg({ t: 'ok', x: 'Info enregistrée !' }); setIFile(null); if (iFileRef.current) iFileRef.current.value = ''; load(); }
    else setMsg({ t: 'err', x: 'Erreur info' });
  };

  const lbl = { display: 'block', fontSize: 12, fontWeight: 700, color: '#4a3030', marginBottom: 4 };
  const inp = { width: '100%', padding: '8px 10px', borderRadius: 6, border: '1px solid #dccfc8', fontSize: 12, boxSizing: 'border-box' };
  const card = { background: '#fff', border: '1px solid #dccfc8', borderRadius: 10, padding: 20, marginBottom: 20 };
  const btn = { padding: '10px 18px', borderRadius: 6, border: 'none', background: '#8b1a2a', color: '#fff', fontWeight: 700, fontSize: 13, cursor: 'pointer' };

  return (
    <div style={{ maxWidth: 720 }}>
      <div style={{ fontFamily: 'Georgia,serif', fontSize: 18, color: '#1a1010', marginBottom: 8 }}>Page d'accueil — « À la une »</div>
      <div style={{ fontSize: 12, color: '#9a8080', marginBottom: 20 }}>Chaque bloc s'enregistre séparément. Décoche « Afficher » pour masquer un bloc sans le supprimer.</div>
      {msg && <div style={{ padding: '8px 12px', borderRadius: 6, marginBottom: 16, background: msg.t === 'ok' ? '#e8f5ee' : '#f5e8e8', color: msg.t === 'ok' ? '#1a5a3a' : '#8b1a2a', fontSize: 12 }}>{msg.x}</div>}

      <div style={card}>
        <div style={{ fontFamily: 'Georgia,serif', fontSize: 15, color: '#8b1a2a', marginBottom: 14 }}>① Média (image ou vidéo)</div>
        {doc?.media?.url && (
          <div style={{ marginBottom: 12 }}>
            {doc.media.mediaType === 'video'
              ? <video src={doc.media.url} controls style={{ width: '100%', maxHeight: 220, borderRadius: 8, background: '#000' }} />
              : <img src={doc.media.url} alt="" style={{ maxWidth: '100%', maxHeight: 220, borderRadius: 8 }} />}
            <div style={{ fontSize: 12, color: '#9a8080', marginTop: 4 }}>Média actuel — réenvoie un fichier pour le remplacer.</div>
          </div>
        )}
        <div style={{ marginBottom: 12 }}><label style={lbl}>Fichier (image ou vidéo)</label>
          <input ref={fileRef} type="file" accept="image/*,video/*" onChange={e => setMFile(e.target.files[0])} style={inp} /></div>
        <div style={{ marginBottom: 12 }}><label style={lbl}>Son (facultatif, mp3) — un haut-parleur s'affichera à côté du titre</label>
          {doc?.media?.audioUrl && <div style={{ marginBottom: 6 }}>
            <audio src={doc.media.audioUrl} controls style={{ width: '100%' }} />
            <button onClick={removeMediaAudio} disabled={saving} style={{ marginTop: 6, padding: '5px 12px', borderRadius: 6, border: '1px solid #e0a0a0', background: '#fff', color: '#c03030', fontSize: 12, cursor: 'pointer' }}>× Supprimer le son</button>
          </div>}
          <input ref={audioRef} type="file" accept="audio/*" onChange={e => setMAudio(e.target.files[0])} style={inp} /></div>
        <div style={{ marginBottom: 12 }}><label style={lbl}>Titre (facultatif)</label>
          <input value={mTitle} onChange={e => setMTitle(e.target.value)} style={inp} /></div>
        <div style={{ marginBottom: 12 }}><label style={lbl}>Texte court (facultatif)</label>
          <textarea value={mText} onChange={e => setMText(e.target.value)} rows={3} style={{ ...inp, resize: 'vertical' }} /></div>
        <div style={{ marginBottom: 12 }}><label style={lbl}>Lien au clic (facultatif, ex : /documentaire ou https://…)</label>
          <input value={mLink} onChange={e => setMLink(e.target.value)} style={inp} /></div>
        <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 16 }}>
          <input type="checkbox" checked={mActive} onChange={e => setMActive(e.target.checked)} id="macc" />
          <label htmlFor="macc" style={{ fontSize: 12, color: '#4a3030' }}>Afficher ce bloc sur l'accueil</label>
        </div>
        <button onClick={saveMedia} disabled={saving} style={btn}>{saving ? 'Enregistrement…' : 'Enregistrer le média'}</button>

        <div style={{ marginTop: 20, paddingTop: 16, borderTop: '1px solid #eaddd8' }}>
          <div style={{ fontSize: 13, fontWeight: 700, color: '#4a3030', marginBottom: 4 }}>Sons à écouter (zone « Écoute »)</div>
          <div style={{ fontSize: 12, color: '#9a8080', marginBottom: 12 }}>Jusqu'à 18 sons. Chaque haut-parleur ne s'affiche que s'il a un son. Choisis une couleur, ajoute le fichier audio.</div>
          <div style={{ display: 'flex', gap: 8, alignItems: 'flex-end', flexWrap: 'wrap', marginBottom: 12 }}>
            <div>
              <label style={{ ...lbl, marginBottom: 4 }}>Couleur</label>
              <input type="color" value={soundColor} onChange={e => setSoundColor(e.target.value)} style={{ width: 48, height: 38, padding: 2, border: '1px solid #dccfc8', borderRadius: 6, cursor: 'pointer' }} />
            </div>
            <div style={{ flex: 1, minWidth: 160 }}>
              <label style={{ ...lbl, marginBottom: 4 }}>Fichier audio (mp3)</label>
              <input ref={soundRef} type="file" accept="audio/*" onChange={e => setSoundFile(e.target.files[0])} style={inp} />
            </div>
            <button onClick={addSound} disabled={saving} style={{ padding: '9px 16px', borderRadius: 6, border: 'none', background: '#1a6a30', color: '#fff', fontSize: 13, fontWeight: 700, cursor: 'pointer' }}>+ Ajouter</button>
          </div>
          {Array.isArray(doc?.media?.sounds) && doc.media.sounds.length > 0 && (
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: 10 }}>
              {doc.media.sounds.map((s, i) => (
                <div key={i} style={{ display: 'flex', alignItems: 'center', gap: 6, background: '#fafaf8', border: '1px solid #dccfc8', borderRadius: 8, padding: '6px 8px' }}>
                  <span style={{ width: 22, height: 22, borderRadius: '50%', background: s.color, display: 'inline-block', flexShrink: 0 }} />
                  <span style={{ fontSize: 12, color: '#4a3030', maxWidth: 130, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }} title={s.name || ''}>{s.name || 'son'}</span>
                  <audio src={s.url} controls style={{ height: 30, maxWidth: 150 }} />
                  <button onClick={() => deleteSound(i)} style={{ padding: '2px 8px', borderRadius: 6, border: '1px solid #e0a0a0', background: '#fff', color: '#c03030', fontSize: 12, cursor: 'pointer' }}>×</button>
                </div>
              ))}
            </div>
          )}
          <div style={{ fontSize: 12, color: '#9a8080', marginTop: 8 }}>{Array.isArray(doc?.media?.sounds) ? doc.media.sounds.length : 0} / 18 son(s)</div>
        </div>
      </div>

      <div style={card}>
        <div style={{ fontFamily: 'Georgia,serif', fontSize: 15, color: '#8b1a2a', marginBottom: 14 }}>② Info</div>
        <div style={{ marginBottom: 12 }}><label style={lbl}>Image / vignette (facultative) — affichée à droite du titre</label>
          {doc?.info?.imageUrl && <div style={{ marginBottom: 6 }}><img src={doc.info.imageUrl} alt="" style={{ width: 70, height: 70, objectFit: 'cover', borderRadius: 8, border: '1px solid #dccfc8' }} /></div>}
          <input ref={iFileRef} type="file" accept="image/*" onChange={e => setIFile(e.target.files[0])} style={inp} /></div>
        <div style={{ marginBottom: 12 }}><label style={lbl}>Titre</label>
          <input value={iTitle} onChange={e => setITitle(e.target.value)} style={inp} /></div>
        <div style={{ marginBottom: 12 }}><label style={lbl}>Texte</label>
          <textarea value={iText} onChange={e => setIText(e.target.value)} rows={4} style={{ ...inp, resize: 'vertical' }} /></div>
        <div style={{ marginBottom: 12 }}><label style={lbl}>Lien au clic (facultatif)</label>
          <input value={iLink} onChange={e => setILink(e.target.value)} style={inp} /></div>
        <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 16 }}>
          <input type="checkbox" checked={iActive} onChange={e => setIActive(e.target.checked)} id="iacc" />
          <label htmlFor="iacc" style={{ fontSize: 12, color: '#4a3030' }}>Afficher ce bloc sur l'accueil</label>
        </div>
        <button onClick={saveInfo} disabled={saving} style={btn}>{saving ? 'Enregistrement…' : 'Enregistrer l\'info'}</button>
      </div>

      <div style={card}>
        <div style={{ fontFamily: 'Georgia,serif', fontSize: 15, color: '#8b1a2a', marginBottom: 14 }}>③ Sondage</div>
        <div style={{ marginBottom: 12 }}><label style={lbl}>Question</label>
          <input value={pQuestion} onChange={e => setPQuestion(e.target.value)} placeholder="Ex : Quel est votre album préféré ?" style={inp} /></div>
        <div style={{ marginBottom: 12 }}>
          <label style={lbl}>Réponses possibles</label>
          {pOptions.map((o, i) => (
            <div key={i} style={{ display: 'flex', gap: 6, marginBottom: 6 }}>
              <input value={o} onChange={e => setPOptions(prev => prev.map((x, j) => j === i ? e.target.value : x))} placeholder={'Réponse ' + (i + 1)} style={inp} />
              {pOptions.length > 2 && <button onClick={() => setPOptions(prev => prev.filter((_, j) => j !== i))} style={{ padding: '0 12px', borderRadius: 6, border: '1px solid #e0a0a0', background: '#fff', color: '#c03030', cursor: 'pointer' }}>×</button>}
            </div>
          ))}
          <button onClick={() => setPOptions(prev => [...prev, ''])} style={{ padding: '6px 12px', borderRadius: 6, border: '1px solid #c49090', background: '#fafaf8', color: '#8b1a2a', fontSize: 12, cursor: 'pointer' }}>+ Ajouter une réponse</button>
        </div>
        <button onClick={createPoll} style={btn}>Créer le sondage</button>

        <div style={{ marginTop: 20 }}>
          <div style={{ fontSize: 13, fontWeight: 700, color: '#4a3030', marginBottom: 10 }}>Sondages ({polls.length})</div>
          {polls.length === 0 && <div style={{ fontSize: 12, color: '#9a8080', fontStyle: 'italic' }}>Aucun sondage.</div>}
          {polls.map(p => (
            <div key={p._id} style={{ background: p.active ? '#fff' : '#f7f5f3', border: p.active ? '1.5px solid #1a6a30' : '1px solid #dccfc8', borderRadius: 8, padding: '12px 14px', marginBottom: 10 }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: 10 }}>
                <div style={{ flex: 1, minWidth: 0 }}>
                  <div style={{ fontSize: 13, fontWeight: 700, color: '#1a1010', marginBottom: 4 }}>{p.active && <span style={{ color: '#1a6a30' }}>● </span>}{p.question}</div>
                  <div style={{ fontSize: 12, color: '#9a8080' }}>{p.options.map(o => o.text + ' (' + o.count + ')').join(' · ')} — {p.total} vote{p.total !== 1 ? 's' : ''}</div>
                </div>
                <div style={{ display: 'flex', gap: 6, flexShrink: 0 }}>
                  {p.active
                    ? <button onClick={() => activatePoll(p._id, false)} style={{ padding: '5px 10px', borderRadius: 6, border: '1px solid #c49090', background: '#f5eeeb', color: '#8b1a2a', fontSize: 12, cursor: 'pointer' }}>Désactiver</button>
                    : <button onClick={() => activatePoll(p._id, true)} style={{ padding: '5px 10px', borderRadius: 6, border: 'none', background: '#1a6a30', color: '#fff', fontSize: 12, cursor: 'pointer' }}>Activer</button>}
                  <button onClick={() => deletePoll(p._id)} style={{ padding: '5px 10px', borderRadius: 6, border: '1px solid #e0a0a0', background: '#fff', color: '#c03030', fontSize: 12, cursor: 'pointer' }}>Suppr.</button>
                </div>
              </div>
            </div>
          ))}
          <div style={{ fontSize: 12, color: '#9a8080', marginTop: 8 }}>Un seul sondage actif à la fois : c'est lui qui s'affiche sur l'accueil.</div>
        </div>
      </div>
    </div>
  );
}
export default function Admin() {
  const [logged, setLogged] = useState(() => sessionStorage.getItem('mjadmin') === 'ok');
  const [checking, setChecking] = useState(true);
  const [activeNav, setActiveNav] = useState('pending');
  const [testimonials, setTestimonials] = useState([]);
  const [artworks, setArtworks] = useState([]);
  const [loading, setLoading] = useState(false);
  const [filterSection, setFilterSection] = useState('');
  const [viewItem, setViewItem] = useState(null);


  const load = async () => {
    setLoading(true);
    try {
      const token = localStorage.getItem('mjtoken') || '';
      const res = await axios.get('/api/admin/pending', { headers: { Authorization: `Bearer ${token}` } });
      setTestimonials(res.data.testimonials || []);
      setArtworks(res.data.artworks || []);
    } catch (e) { console.error(e); }
    setLoading(false);
  };

  useEffect(() => { if (logged) load(); }, [logged]);

  useEffect(() => {
    let annule = false;
    (async () => {
      try {
        const t = localStorage.getItem('mjtoken');
        if (t) {
          const res = await fetch('/api/auth/me', { headers: { Authorization: 'Bearer ' + t } });
          if (res.ok) {
            const me = await res.json();
            if (!annule && me && me.role === 'admin') { sessionStorage.setItem('mjadmin', 'ok'); setLogged(true); }
          }
        }
      } catch {}
      if (!annule) setChecking(false);
    })();
    return () => { annule = true; };
  }, []);

  const approve = async (id) => {
    try {
      await axios.patch(`/api/admin/testimonial/${id}`, { status: 'approved' }, { headers: { Authorization: 'Bearer ' + (localStorage.getItem('mjtoken') || '') } });
      setTestimonials(prev => prev.map(t => t._id === id ? { ...t, status: 'approved' } : t));
      if (viewItem?._id === id) setViewItem(v => ({ ...v, status: 'approved' }));
    } catch(e) { console.error(e); }
  };

  const reject = async (id) => {
    try {
      await axios.patch(`/api/admin/testimonial/${id}`, { status: 'rejected' }, { headers: { Authorization: 'Bearer ' + (localStorage.getItem('mjtoken') || '') } });
      setTestimonials(prev => prev.map(t => t._id === id ? { ...t, status: 'rejected' } : t));
      if (viewItem?._id === id) setViewItem(v => ({ ...v, status: 'rejected' }));
    } catch(e) { console.error(e); }
  };

  const approveArt = async (id) => {
    try {
      await axios.patch(`/api/admin/artwork/${id}`, { status: 'approved' }, { headers: { Authorization: 'Bearer ' + (localStorage.getItem('mjtoken') || '') } });
      setArtworks(prev => prev.map(a => a._id === id ? { ...a, status: 'approved' } : a));
    } catch(e) { console.error(e); }
  };

  const rejectArt = async (id) => {
    try {
      await axios.patch(`/api/admin/artwork/${id}`, { status: 'rejected' }, { headers: { Authorization: 'Bearer ' + (localStorage.getItem('mjtoken') || '') } });
      setArtworks(prev => prev.map(a => a._id === id ? { ...a, status: 'rejected' } : a));
    } catch(e) { console.error(e); }
  };

  const del = async (id) => {
    if (!window.confirm('Supprimer definitivement ce temoignage ? Action irreversible.')) return;
    try {
      await axios.delete(`/api/admin/testimonial/${id}`, { headers: { Authorization: 'Bearer ' + (localStorage.getItem('mjtoken') || '') } });
      setTestimonials(prev => prev.filter(t => t._id !== id));
      if (viewItem?._id === id) setViewItem(null);
    } catch(e) { console.error(e); }
  };

  const deleteArt = async (id) => {
    if (!window.confirm('Supprimer definitivement cette oeuvre ? Action irreversible.')) return;
    try {
      await axios.delete(`/api/admin/artwork/${id}`, { headers: { Authorization: 'Bearer ' + (localStorage.getItem('mjtoken') || '') } });
      setArtworks(prev => prev.filter(a => a._id !== id));
    } catch(e) { console.error(e); }
  };

  if (checking) return <div style={{ minHeight: '100vh', background: '#0a0608', display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'rgba(255,255,255,0.6)', fontSize: 14 }}>Verification de l acces...</div>;
  if (!logged) return <div style={{ minHeight: '100vh', background: '#0a0608', display: 'flex', flexDirection: 'column', gap: 12, alignItems: 'center', justifyContent: 'center', color: '#fff', textAlign: 'center', padding: 24 }}><div style={{ fontFamily: 'Georgia,serif', fontSize: 20 }}>Acces reserve aux administrateurs</div><div style={{ fontSize: 13, color: 'rgba(255,255,255,0.5)' }}>Connectez-vous au site avec un compte administrateur.</div></div>;

  const sections = ['scene', 'rencontre', 'etsi', 'art', 'documentaire', 'photos'];
  const CAT_LABELS = { scene: 'Scène', rencontre: 'Rencontres', etsi: 'Et si…', documentaire: 'Documentaire', photos: 'Photos', art: 'Art' };
  const CAT_ORDER = ['scene', 'rencontre', 'etsi', 'documentaire', 'photos', 'art'];
  const catOrd = k => { const i = CAT_ORDER.indexOf(k); return i === -1 ? 99 : i; };
  const catNav = [...new Set(testimonials.filter(t => t.status === 'approved').map(t => t.section).filter(Boolean))]
    .sort((a, b) => catOrd(a) - catOrd(b))
    .map(sec => ({ id: 'cat:' + sec, label: CAT_LABELS[sec] || sec, count: testimonials.filter(t => t.status === 'approved' && t.section === sec).length }));
  const filtered = testimonials.filter(t => {
    if (activeNav === 'pending') return t.status === 'pending';
    if (activeNav === 'rejected') return t.status === 'rejected';
    if (activeNav.indexOf('cat:') === 0) return t.status === 'approved' && t.section === activeNav.slice(4);
    return true;
  }).filter(t => filterSection ? t.section === filterSection : true);

  const titreSection = {
    pending: 'Témoignages en attente', approved: 'Témoignages approuvés',
    rejected: 'Témoignages refusés', art: 'Art des fans', videos: 'Vidéos Michael',
    graphicart: 'Art graphique de Michael',
    entourage: 'Entourage de Michael',
    enfants: 'Michael & les enfants',
    legende: 'La legende continue',
    citations: 'Citations MJ',
    membres: 'Membres',
    stats: 'Statistiques',
  };

  return (
    <div style={{ minHeight: '100vh', background: '#fafaf8', display: 'grid', gridTemplateColumns: '220px 1fr' }}>
      <div style={{ background: '#1a1010', display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
        <div style={{ padding: '20px', borderBottom: '1px solid rgba(255,255,255,0.08)' }}>
          <div style={{ fontFamily: 'Georgia,serif', fontSize: '14px', color: '#fff' }}>MJ <span style={{ color: '#e8a0a0' }}>—</span> Admin</div>
          <div style={{ fontSize: '12px', color: 'rgba(255,255,255,0.3)', marginTop: '3px' }}>Interface de modération</div>
        </div>

        <div style={{ padding: '16px 12px 8px' }}>
          <div style={{ fontSize: '12px', letterSpacing: '0.12em', color: 'rgba(255,255,255,0.3)', marginBottom: '8px', padding: '0 8px' }}>MODÉRATION</div>
          {[
            { id: 'pending', label: '📥 En attente', count: testimonials.filter(t => t.status === 'pending').length },
            { id: 'rejected', label: '❌ Refusés', count: testimonials.filter(t => t.status === 'rejected').length },
            { id: 'signalements', label: '🚩 Signalements', count: 0 },
          ].map(item => (
            <div key={item.id} onClick={() => { setActiveNav(item.id); setViewItem(null); }}
              style={{ display: 'flex', alignItems: 'center', gap: '10px', padding: '9px 12px', borderRadius: '7px', cursor: 'pointer', marginBottom: '2px', color: activeNav === item.id ? '#fff' : 'rgba(255,255,255,0.5)', background: activeNav === item.id ? 'rgba(139,26,42,0.4)' : 'transparent', fontSize: '12px' }}
              onMouseEnter={e => { if (activeNav !== item.id) e.currentTarget.style.background = 'rgba(255,255,255,0.06)'; }}
              onMouseLeave={e => { if (activeNav !== item.id) e.currentTarget.style.background = 'transparent'; }}>
              {item.label}
              {item.count > 0 && <span style={{ marginLeft: 'auto', background: '#8b1a2a', color: '#fff', borderRadius: '10px', padding: '1px 7px', fontSize: '12px' }}>{item.count}</span>}
            </div>
          ))}
        </div>

        {catNav.length > 0 && (
        <div style={{ padding: '16px 12px 8px' }}>
          <div style={{ fontSize: '12px', letterSpacing: '0.12em', color: 'rgba(255,255,255,0.3)', marginBottom: '8px', padding: '0 8px' }}>TÉMOIGNAGES PUBLIÉS</div>
          {catNav.map(item => (
            <div key={item.id} onClick={() => { setActiveNav(item.id); setViewItem(null); setFilterSection(''); }}
              style={{ display: 'flex', alignItems: 'center', gap: '10px', padding: '9px 12px', borderRadius: '7px', cursor: 'pointer', marginBottom: '2px', color: activeNav === item.id ? '#fff' : 'rgba(255,255,255,0.5)', background: activeNav === item.id ? 'rgba(139,26,42,0.4)' : 'transparent', fontSize: '12px' }}
              onMouseEnter={e => { if (activeNav !== item.id) e.currentTarget.style.background = 'rgba(255,255,255,0.06)'; }}
              onMouseLeave={e => { if (activeNav !== item.id) e.currentTarget.style.background = 'transparent'; }}>
              {item.label}
              {item.count > 0 && <span style={{ marginLeft: 'auto', background: '#8b1a2a', color: '#fff', borderRadius: '10px', padding: '1px 7px', fontSize: '12px' }}>{item.count}</span>}
            </div>
          ))}
        </div>
        )}

        <div style={{ padding: '16px 12px 8px' }}>
          <div style={{ fontSize: '12px', letterSpacing: '0.12em', color: 'rgba(255,255,255,0.3)', marginBottom: '8px', padding: '0 8px' }}>CONTENU</div>
          {[
            { id: 'videos', label: '🎬 Vidéos Michael' },
            { id: 'art', label: '🎨 Art des fans', count: artworks.filter(a => a.status === 'pending').length },
            { id: 'graphicart', label: '🖼 Art graphique', count: 0 },
            { id: 'entourage', label: '👥 Entourage', count: 0 },
            { id: 'enfants', label: '👶 Enfants', count: 0 },
            { id: 'legende', label: '✨ La legende continue', count: 0 },
            { id: 'legende-actus', label: '📰 Actus Légende', count: 0 },
            { id: 'events', label: '🌍 Événements carte', count: 0 },
            { id: 'citations', label: '💬 Citations MJ', count: 0 },
            { id: 'membres', label: 'Membres', count: 0 },
            { id: 'soumissions', label: '📥 Soumissions', count: 0 },
            { id: 'accueil', label: '🏠 Accueil', count: 0 },
          ].map(item => (
            <div key={item.id} onClick={() => { setActiveNav(item.id); setViewItem(null); }}
              style={{ display: 'flex', alignItems: 'center', gap: '10px', padding: '9px 12px', borderRadius: '7px', cursor: 'pointer', marginBottom: '2px', color: activeNav === item.id ? '#fff' : 'rgba(255,255,255,0.5)', background: activeNav === item.id ? 'rgba(139,26,42,0.4)' : 'transparent', fontSize: '12px' }}
              onMouseEnter={e => { if (activeNav !== item.id) e.currentTarget.style.background = 'rgba(255,255,255,0.06)'; }}
              onMouseLeave={e => { if (activeNav !== item.id) e.currentTarget.style.background = 'transparent'; }}>
              {item.label}
              {item.count > 0 && <span style={{ marginLeft: 'auto', background: '#c06030', color: '#fff', borderRadius: '10px', padding: '1px 7px', fontSize: '12px' }}>{item.count}</span>}
            </div>
          ))}
        </div>

        <div style={{ padding: '16px 12px 8px' }}>
          <div style={{ fontSize: '12px', letterSpacing: '0.12em', color: 'rgba(255,255,255,0.3)', marginBottom: '8px', padding: '0 8px' }}>GESTION</div>
          {[{ id: 'stats', label: '📊 Statistiques' }, { id: 'settings', label: '⚙️ Paramètres' }].map(item => (
            <div key={item.id} onClick={() => setActiveNav(item.id)}
              style={{ display: 'flex', alignItems: 'center', gap: '10px', padding: '9px 12px', borderRadius: '7px', cursor: 'pointer', marginBottom: '2px', color: 'rgba(255,255,255,0.5)', fontSize: '12px' }}
              onMouseEnter={e => e.currentTarget.style.background = 'rgba(255,255,255,0.06)'}
              onMouseLeave={e => e.currentTarget.style.background = 'transparent'}>
              {item.label}
            </div>
          ))}
        </div>

        <div style={{ marginTop: 'auto', padding: '16px 12px' }}>
          <div onClick={() => { sessionStorage.removeItem('mjadmin'); setLogged(false); }}
            style={{ display: 'flex', alignItems: 'center', gap: '10px', padding: '9px 12px', borderRadius: '7px', cursor: 'pointer', color: 'rgba(255,255,255,0.3)', fontSize: '12px' }}
            onMouseEnter={e => e.currentTarget.style.color = '#fff'}
            onMouseLeave={e => e.currentTarget.style.color = 'rgba(255,255,255,0.3)'}>
            🚪 Se déconnecter
          </div>
        </div>
      </div>

      <div style={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
        <div style={{ background: '#fff', borderBottom: '1px solid #dccfc8', padding: '0 24px', height: '52px', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <div style={{ fontFamily: 'Georgia,serif', fontSize: '18px', color: '#1a1010' }}>
            {activeNav.indexOf('cat:') === 0 ? ('Publiés — ' + (CAT_LABELS[activeNav.slice(4)] || activeNav.slice(4))) : (titreSection[activeNav] || 'Administration')}
          </div>
          {['pending', 'rejected'].includes(activeNav) && (
            <div style={{ display: 'flex', gap: '8px' }}>
              <select value={filterSection} onChange={e => setFilterSection(e.target.value)} style={{ border: '1px solid #dccfc8', borderRadius: '6px', padding: '5px 10px', fontSize: '12px', color: '#6a5050', background: '#fff' }}>
                <option value="">Toutes les sections</option>
                {sections.map(s => <option key={s} value={s}>{s}</option>)}
              </select>
              <button onClick={load} style={{ background: '#f5eeeb', color: '#8b1a2a', border: '1px solid #c49090', borderRadius: '6px', padding: '5px 14px', fontSize: '12px', cursor: 'pointer' }}>↻ Actualiser</button>
            </div>
          )}
        </div>

        {['pending', 'rejected'].includes(activeNav) && (
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3,1fr)', borderBottom: '1px solid #dccfc8' }}>
            {[
              { n: testimonials.filter(t => t.status === 'pending').length, l: 'en attente', badge: true },
              { n: testimonials.filter(t => t.status === 'rejected').length, l: 'refusés' },
              { n: testimonials.length, l: 'total' },
            ].map((s, i) => (
              <div key={i} style={{ padding: '16px 20px', background: '#fff', borderRight: i < 2 ? '1px solid #dccfc8' : 'none', textAlign: 'center' }}>
                <div style={{ fontSize: '24px', fontWeight: '500', color: '#8b1a2a', fontFamily: 'Georgia,serif' }}>{s.n}</div>
                <div style={{ fontSize: '12px', color: '#9a8080', marginTop: '3px' }}>{s.l}</div>
                {s.badge && s.n > 0 && <div style={{ display: 'inline-block', fontSize: '12px', background: '#fff3f0', color: '#c03030', padding: '2px 7px', borderRadius: '10px', marginTop: '4px' }}>À modérer</div>}
              </div>
            ))}
          </div>
        )}

        <div style={{ padding: '20px 24px', overflowY: 'auto', flex: 1 }}>
          {activeNav === 'stats' ? (
            <SectionStats />
          ) : activeNav === 'signalements' ? (
            <SectionSignalements />
          ) : activeNav === 'membres' ? (
            <SectionMembres />
          ) : activeNav === 'videos' ? (
            <SectionVideos />
          ) : activeNav === 'graphicart' ? (
            <SectionArtGraphique />
          ) : activeNav === 'entourage' ? (
            <SectionEntourage />
          ) : activeNav === 'enfants' ? (
            <SectionEnfants />
          ) : activeNav === 'legende' ? (
            <SectionLegende />
          ) : activeNav === 'legende-actus' ? (
            <SectionLegendeActus />
          ) : activeNav === 'soumissions' ? (
            <SectionSoumissions />
          ) : activeNav === 'accueil' ? (
            <SectionAccueil />
          ) : activeNav === 'citations' ? (
            <SectionCitations />
          ) : activeNav === 'art' ? (
            artworks.length === 0 ? (
              <div style={{ textAlign: 'center', padding: '40px' }}>
                <div style={{ fontSize: '32px', marginBottom: '12px' }}>🎨</div>
                <div style={{ fontSize: '14px', color: '#9a8080' }}>Aucune oeuvre en attente.</div>
              </div>
            ) : (
              <div>
                {[{ key: 'pending', label: 'En attente' }, { key: 'approved', label: 'Publiées' }, { key: 'rejected', label: 'Refusées' }].map(grp => {
                  const liste = artworks.filter(a => a.status === grp.key);
                  if (liste.length === 0) return null;
                  return (
                  <div key={grp.key} style={{ marginBottom: 24 }}>
                    <div style={{ fontFamily: 'Georgia,serif', fontSize: 15, color: '#8b1a2a', marginBottom: 12 }}>{grp.label} ({liste.length})</div>
                    <div style={{ display: 'grid', gap: 16 }}>
                {liste.map(a => (
                  <div key={a._id} style={{ background: '#fff', border: '1px solid #dccfc8', borderRadius: 10, padding: 16 }}>
                    <div style={{ display: 'flex', gap: 16, alignItems: 'flex-start' }}>
                      {a.image
                        ? <img src={a.image} alt="" style={{ width: 140, height: 140, objectFit: 'cover', borderRadius: 8, flexShrink: 0 }} />
                        : a.video
                          ? <video src={a.video} controls style={{ width: 200, borderRadius: 8, background: '#000', flexShrink: 0 }} />
                          : null}
                      <div style={{ flex: 1, minWidth: 0 }}>
                        <div style={{ fontFamily: 'Georgia,serif', fontSize: 16, color: '#1a1010' }}>{a.title || 'Sans titre'}</div>
                        <div style={{ fontSize: 12, color: '#6a5050', margin: '4px 0 8px' }}>{a.authorName}{a.authorCountry ? ' · ' + a.authorCountry : ''}{a.annee ? ' · ' + a.annee : ''} · {a.type}</div>
                        {a.description && <div style={{ fontSize: 13, color: '#4a3030', lineHeight: 1.5, marginBottom: 8 }}>{a.description}</div>}
                        {a.image && a.video && <video src={a.video} controls style={{ width: 240, borderRadius: 8, background: '#000', marginBottom: 8, display: 'block' }} />}
                        {a.videoUrl && (() => {
                          const yt = a.videoUrl.match(/(?:youtube\.com\/(?:watch\?v=|embed\/|shorts\/)|youtu\.be\/)([\w-]{11})/);
                          const vm = a.videoUrl.match(/vimeo\.com\/(?:video\/)?(\d+)/);
                          const embed = yt ? 'https://www.youtube.com/embed/' + yt[1] : (vm ? 'https://player.vimeo.com/video/' + vm[1] : '');
                          return embed
                            ? <iframe title="v" src={embed} style={{ width: '100%', maxWidth: 360, aspectRatio: '16 / 9', border: 'none', borderRadius: 8, marginBottom: 8, display: 'block' }} allowFullScreen />
                            : <a href={a.videoUrl} target="_blank" rel="noreferrer" style={{ fontSize: 13, color: '#8b1a2a', display: 'inline-block', marginBottom: 8 }}>{a.videoUrl}</a>;
                        })()}
                        <div style={{ display: 'flex', gap: 10, marginTop: 4 }}>
                          {a.status !== 'approved' && <button onClick={() => approveArt(a._id)} style={{ background: '#1a6a30', color: '#fff', border: 'none', borderRadius: 7, padding: '8px 20px', fontSize: 13, cursor: 'pointer', fontWeight: 500 }}>✓ Approuver</button>}
                          {a.status === 'pending' && <button onClick={() => rejectArt(a._id)} style={{ background: '#fff', color: '#c03030', border: '1px solid #e0a0a0', borderRadius: 7, padding: '8px 20px', fontSize: 13, cursor: 'pointer' }}>✗ Refuser</button>}
                          <button onClick={() => deleteArt(a._id)} style={{ background: '#8b1a2a', color: '#fff', border: 'none', borderRadius: 7, padding: '8px 20px', fontSize: 13, cursor: 'pointer' }}>🗑 Supprimer</button>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
                    </div>
                  </div>
                  );
                })}
              </div>
            )
          ) : loading ? (
            <div style={{ textAlign: 'center', padding: '40px', color: '#9a8080' }}>Chargement…</div>
          ) : viewItem ? (
            <TestiFull t={viewItem} onClose={() => setViewItem(null)} onApprove={approve} onReject={reject} onDelete={del} />
          ) : filtered.length === 0 ? (
            <div style={{ textAlign: 'center', padding: '40px' }}>
              <div style={{ fontSize: '32px', marginBottom: '12px' }}>✓</div>
              <div style={{ fontSize: '14px', color: '#9a8080' }}>Aucun témoignage à afficher.</div>
            </div>
          ) : (
            filtered.map(t => <TestiCard key={t._id} t={t} onApprove={approve} onReject={reject} onView={setViewItem} onDelete={del} />)
          )}
        </div>
      </div>
    </div>
  );
}
